/* ===========================================================================
   VA_REFUSAL — THE single refusal surface (owner 2026-08-17/18).
   One popup, one wording; classic builder, beta builder and the upload page
   all call VA_REFUSAL.show() / .showDeferred().

     text(hit)          -> rule + no-refund warning (for non-popup surfaces)
     appealUrl(hit,ctx) -> /pages/contact fallback carrying the diagnosis
     show(hit,opts)     -> popup now (uploads/logos: no typing involved)
     showDeferred(...)  -> popup once the field SETTLES (typed inputs)

   Design (owner-reviewed 2026-08-18):
   - Calm, not punitive: amber "Content policy" eyebrow, the tripped word as a
     chip, the rule in plain words, the no-refund policy demoted to fine print.
     Brand purple carries the primary action.
   - Appeal is INLINE: one tap swaps the card to a small form. The customer can
     edit ONLY two things — their email and why we should print it. The blocked
     term and what they typed are shown as locked, read-only facts and travel
     with the submission untouched. POSTs to Shopify /contact with the full
     diagnosis as hidden fields; falls back to the prefilled contact page only
     if the POST fails. No navigation — the design in progress is never lost.
   - showDeferred exists because half the short block terms are prefixes of
     legitimate words ("Mast"→"Master Mix", "Deca"→"Decapeptide"): wait 1.4s
     or blur, RE-CHECK the finished value, only then refuse.
   - No body scroll-lock and no focus on touch devices: both physically moved
     the page (iOS scrolls to a focused element's DOM position, and this
     overlay sits at the END of body — the page bottom).
   - "Change it" clears the field AND wipes the error styling the clearing
     itself provokes (required-field validation re-fires on empty).
   =========================================================================== */
(function () {
  if (window.VA_REFUSAL && window.VA_REFUSAL.inlineAppeal) return;

  var REASONS = {
    brand: 'is a registered pharmaceutical brand name. We can print the generic compound name, but not another company’s trademark.',
    company: 'is a pharmaceutical company name. We can’t print another manufacturer’s name or logo on a label.',
    dea: 'is a controlled substance under the DEA schedules. We can’t print labels for scheduled drugs.',
    hgh: 'is a restricted growth-hormone product. We can’t print labels for it.',
    steroid: 'is a steroid product. We can\u2019t print labels for it.',
    iu: 'is an IU strength. We can\u2019t print strengths in IU. Please use mg or mcg.',
    mgml: 'is an mg/mL (oil) concentration. We can\u2019t print it. Please give the amount per vial, e.g. 10 mg.',
    route: 'is a route-of-administration instruction. Telling a person how to take a compound would make the label a misbranded drug under FDA rules — research labels can’t carry human-use directions.',
    dosing: 'is a human dosing instruction. Research labels can’t carry dosing schedules or directions for use.',
    claims: 'is a medical or treatment claim. FDA rules prohibit disease, weight-loss or benefit claims on research labels.',
    pharmacy: 'appears on prescription / pharmacy dispense labels. We can’t print anything that imitates a pharmacy label or a government or regulatory mark.'
  };
  var CATS = window.VA_BLOCK_CATS || {};
  var POLICY_NAMES = {
    brand: 'Registered trademarks — brand names',
    company: 'Registered trademarks — manufacturers',
    dea: 'Controlled substances — DEA schedules',
    hgh: 'Restricted products — growth hormone',
    steroid: 'Restricted products \u2014 steroids',
    iu: 'Strength units \u2014 IU',
    mgml: 'Strength units \u2014 oil concentrations (mg/mL)',
    route: 'Human-use directions — FDA misbranding',
    dosing: 'Human-use directions — FDA misbranding',
    claims: 'Medical claims — FDA regulations',
    pharmacy: 'Pharmacy label imitation'
  };
  var WARN = 'Spelling variations and work-arounds are not printed — those orders are cancelled and not refunded.';

  function cat(term) {
    var t = String(term || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
    if (CATS[t]) return CATS[t];
    var ws = String(term || '').toLowerCase().split(/[^a-z0-9]+/);
    for (var i = 0; i < ws.length; i++) if (CATS[ws[i]]) return CATS[ws[i]];
    return 'brand';
  }
  /* 2026-09-23: a vaRestrictedHit hit carries its own category (steroid / iu / mgml
     have no entry in VA_BLOCK_CATS; a brand / company hit names the brand it spells) */
  function catOf(hit) {
    if (hit && typeof hit === 'object' && hit.category && POLICY_NAMES[hit.category]) return hit.category;
    return cat(termOf(hit));
  }
  function termOf(hit) {
    return (hit && hit.term) ? String(hit.term).trim() : String(hit || '').trim();
  }
  function reasonOnly(hit) {
    if (hit && typeof hit === 'object' && hit.restricted && hit.note) return String(hit.note);
    return '“' + termOf(hit) + '” ' + (REASONS[catOf(hit)] || REASONS.brand);
  }
  function text(hit) { return reasonOnly(hit) + ' ' + WARN; }

  function collectMeta(hit, ctx) {
    ctx = ctx || {};
    var meta = {
      'Blocked term': termOf(hit),
      'Rule': catOf(hit),
      'Why blocked': reasonOnly(hit),
      'Field': ctx.field || '',
      'Surface': ctx.surface || '',
      'Full text entered': String(ctx.value || '').slice(0, 300),
      'From page': location.href,
      'When': new Date().toISOString(),
      'Screen': (screen.width + 'x' + screen.height),
      'UA': navigator.userAgent
    };
    try { if (window.__st && window.__st.cid) meta['Shopify customer id'] = String(window.__st.cid); } catch (e) {}
    try {
      if (window.sel && window.sel.bgTitle) meta['Design'] = String(window.sel.bgTitle).slice(0, 80);
      if (window.sel && window.sel.mat) meta['Material'] = String(window.sel.mat).slice(0, 40);
      if (window.sel && window.sel.packs) meta['Packs'] = String(window.sel.packs);
    } catch (e) {}
    try { var lb = localStorage.getItem('vbf_draft'); if (lb) meta['Builder draft'] = lb.slice(0, 900); } catch (e) {}
    return meta;
  }
  function appealUrl(hit, ctx) {
    ctx = ctx || {};
    var q = ['va_appeal=1', 't=' + encodeURIComponent(termOf(hit).slice(0, 80)),
             'c=' + encodeURIComponent(catOf(hit)),
             'f=' + encodeURIComponent(ctx.field || ''),
             's=' + encodeURIComponent(ctx.surface || 'builder')];
    if (ctx.value) q.push('v=' + encodeURIComponent(String(ctx.value).slice(0, 160)));
    return '/pages/contact?' + q.join('&');
  }

  var openEl = null, lastFocus = null;
  function isTouch() {
    try { return window.matchMedia && window.matchMedia('(pointer: coarse)').matches; } catch (e) { return false; }
  }

  function show(hit, opts) {
    opts = opts || {};
    if (openEl) return openEl;
    lastFocus = document.activeElement;

    var wrap = document.createElement('div');
    wrap.id = 'va-refusal-modal';
    wrap.setAttribute('role', 'alertdialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'va-rf-h');
    wrap.setAttribute('aria-describedby', 'va-rf-p');
    wrap.style.cssText = 'position:fixed;inset:0;z-index:2147483000;'
      + 'background:rgba(9,9,15,.82);'
      + 'display:flex;align-items:center;justify-content:center;'
      + 'padding:calc(18px + env(safe-area-inset-top)) 16px calc(18px + env(safe-area-inset-bottom));'
      + '-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);overscroll-behavior:contain;';

    var card = document.createElement('div');
    card.style.cssText = 'box-sizing:border-box;max-width:470px;width:100%;'
      + 'background:#16141f;color:#e9e6f2;'
      + 'border:1px solid #2c2939;border-top:3px solid #8a3944;border-radius:12px;'
      + 'padding:22px 24px 20px;'
      + 'box-shadow:0 24px 64px rgba(0,0,0,.55);'
      + 'font:600 14.5px/1.62 system-ui,-apple-system,"Segoe UI",sans-serif;'
      + 'max-height:calc(100vh - 44px);overflow:auto;-webkit-overflow-scrolling:touch;';

    var eyebrow = document.createElement('div');
    eyebrow.style.cssText = 'margin:0 0 14px;padding:0 0 10px;border-bottom:1px solid #262331;'
      + 'font:700 10.5px/1 system-ui;letter-spacing:.18em;text-transform:uppercase;color:#8f8aa4;';
    eyebrow.textContent = 'Content policy notice';

    var h = document.createElement('div');
    h.id = 'va-rf-h';
    h.style.cssText = 'font:700 18.5px/1.3 system-ui;letter-spacing:-.2px;margin:0 0 14px;color:#fff;';
    h.textContent = 'This content can’t be printed';

    var chip = document.createElement('div');
    chip.style.cssText = 'margin:0 0 14px;padding:10px 13px;background:#100e17;'
      + 'border:1px solid #2c2939;border-left:3px solid #8a3944;border-radius:8px;'
      + 'overflow-wrap:anywhere;';
    var chipK = document.createElement('div');
    chipK.style.cssText = 'font:700 10px/1 system-ui;letter-spacing:.16em;'
      + 'text-transform:uppercase;color:#7d7894;margin:0 0 5px;';
    chipK.textContent = 'Blocked term';
    var chipV = document.createElement('div');
    chipV.style.cssText = 'font:600 14.5px/1.35 ui-monospace,SFMono-Regular,Menlo,monospace;color:#e9e6f2;';
    chipV.textContent = termOf(hit);
    chip.appendChild(chipK); chip.appendChild(chipV);

    var p = document.createElement('div');
    p.id = 'va-rf-p';
    p.style.cssText = 'color:#c9c5d8;margin:0 0 10px;overflow-wrap:anywhere;font-weight:500;';
    p.textContent = reasonOnly(hit);
    var polref = document.createElement('div');
    polref.style.cssText = 'color:#7d7894;font:600 12px/1.5 system-ui;margin:0 0 16px;';
    polref.textContent = 'Policy reference: ' + (POLICY_NAMES[catOf(hit)] || POLICY_NAMES.brand);

    var fine = document.createElement('div');
    fine.style.cssText = 'margin:0 0 18px;padding:12px 0 0;border-top:1px solid #262331;'
      + 'color:#8f8aa4;font:500 12.5px/1.6 system-ui;';
    fine.textContent = WARN;

    var row = document.createElement('div');
    row.style.cssText = 'display:flex;flex-direction:column;gap:10px;';
    var ok = document.createElement('button');
    ok.type = 'button';
    ok.textContent = 'Change it';
    ok.style.cssText = 'box-sizing:border-box;width:100%;min-height:48px;'
      + 'background:#5b48c9;border:0;border-radius:9px;color:#fff;'
      + 'font:700 15px/1 system-ui;padding:14px 16px;cursor:pointer;';
    var ap = document.createElement('button');
    ap.type = 'button';
    ap.textContent = 'Request a review';
    ap.style.cssText = 'box-sizing:border-box;width:100%;min-height:44px;'
      + 'background:transparent;border:1px solid #3a3550;border-radius:9px;color:#b7b1d0;'
      + 'font:600 14px/1 system-ui;padding:12px 16px;cursor:pointer;';
    row.appendChild(ok); row.appendChild(ap);

    /* ---- inline appeal (owner 2026-08-18): only TWO things are editable —
       email and why. The blocked term and what they typed are locked facts,
       rendered read-only and attached to the submission untouched. ---------- */
    var panel = document.createElement('div');
    panel.style.cssText = 'display:none;margin:2px 0 0;';
    var locked = document.createElement('div');
    locked.style.cssText = 'margin:0 0 12px;padding:11px 13px;background:#100e17;'
      + 'border:1px solid #2c2939;border-left:3px solid #8a3944;border-radius:8px;color:#b3aec6;'
      + 'font:500 12.5px/1.7 system-ui;overflow-wrap:anywhere;';
    var lockRow = function (k, v) {
      var d = document.createElement('div');
      var b = document.createElement('span');
      b.style.cssText = 'color:#7d7894;font-weight:700;';
      b.textContent = k + ': ';
      d.appendChild(b);
      d.appendChild(document.createTextNode(v));
      return d;
    };
    locked.appendChild(lockRow('Blocked word', termOf(hit)));
    locked.appendChild(lockRow('Why we blocked it', reasonOnly(hit)));
    if (opts.value && String(opts.value).trim() !== termOf(hit)) {
      locked.appendChild(lockRow('You typed', String(opts.value).slice(0, 120)));
    }
    if (opts.field) locked.appendChild(lockRow('Field', opts.field));

    var fld = 'box-sizing:border-box;width:100%;background:#100e17;border:1px solid #2c2939;'
      + 'border-radius:9px;color:#e9e6f2;font:500 15px/1.5 system-ui;padding:12px 13px;outline:none;';
    var em = document.createElement('input');
    em.type = 'email'; em.required = true; em.placeholder = 'Your email';
    em.autocomplete = 'email';
    em.setAttribute('aria-label', 'Your email');
    em.style.cssText = fld + 'margin:0 0 10px;';
    try { var sv = localStorage.getItem('va_appeal_email'); if (sv) em.value = sv; } catch (e) {}
    var msg = document.createElement('textarea');
    msg.rows = 4;
    msg.placeholder = 'Why should we print this? What is it, and what’s it for?';
    msg.setAttribute('aria-label', 'Why should we print this');
    msg.style.cssText = fld + 'margin:0 0 10px;resize:vertical;min-height:96px;';
    var note = document.createElement('div');
    note.style.cssText = 'color:#8f8aa4;font:500 12.5px/1.6 system-ui;margin:0 0 12px;';
    note.textContent = 'Reviews are handled by a member of our team. You will receive a reply within 24 business hours.';
    var send = document.createElement('button');
    send.type = 'button';
    send.textContent = 'Submit for review';
    send.style.cssText = ok.style.cssText;
    var back = document.createElement('button');
    back.type = 'button';
    back.textContent = 'Back';
    back.style.cssText = ap.style.cssText + 'margin-top:10px;';
    /* "I ordered this before" is not a reason we can accept — the policy
       applies to reprints too. Detect the claim and answer it in place. */
    var PRECEDENT = new RegExp(
      '(order|bought|purchas|print|reorder|re-order|got)[a-z]*[^.]{0,24}' +
      '(before|previous|previosly|last (time|month|year|order)|in the past)' +
      '|previous order|past order|last order|buy (it |this )?again|' +
      'bought (it |this )?again|you (guys )?(printed|made)|always order', 'i');
    var tosWarn = document.createElement('div');
    tosWarn.style.cssText = 'display:none;margin:0 0 12px;padding:11px 13px;background:#100e17;'
      + 'border:1px solid #2c2939;border-left:3px solid #8a3944;border-radius:8px;'
      + 'color:#c9c5d8;font:500 12.5px/1.65 system-ui;';
    tosWarn.textContent = 'Please note: a previous order does not qualify a label for printing. '
      + 'Our content policy applies to reprints as well — under the current Terms of '
      + 'Service, a design we printed in the past can still be refused. If you have a '
      + 'different reason, add it below.';
    panel.appendChild(locked); panel.appendChild(em); panel.appendChild(msg);
    panel.appendChild(tosWarn); panel.appendChild(note);
    panel.appendChild(send); panel.appendChild(back);

    function setMode(appeal) {
      p.style.display = appeal ? 'none' : '';
      fine.style.display = appeal ? 'none' : '';
      row.style.display = appeal ? 'none' : '';
      chip.style.display = appeal ? 'none' : '';
      panel.style.display = appeal ? '' : 'none';
      h.textContent = appeal ? 'Request a review' : 'This content can’t be printed';
      if (appeal && !isTouch()) { try { em.focus({ preventScroll: true }); } catch (e) {} }
    }
    ap.addEventListener('click', function () { setMode(true); polref.style.display='none'; });
    back.addEventListener('click', function () { setMode(false); polref.style.display=''; });

    send.addEventListener('click', function () {
      var mail = (em.value || '').trim();
      var why = (msg.value || '').trim();
      if (!mail || mail.indexOf('@') < 1) {
        em.style.borderColor = '#ff7a7a';
        if (!isTouch()) { try { em.focus({ preventScroll: true }); } catch (e) {} }
        return;
      }
      if (!why) {
        msg.style.borderColor = '#ff7a7a';
        if (!isTouch()) { try { msg.focus({ preventScroll: true }); } catch (e) {} }
        return;
      }
      if (!send.dataset.warned && PRECEDENT.test(why)) {
        send.dataset.warned = '1';
        tosWarn.style.display = '';
        send.textContent = 'Submit anyway';
        try { void 0/* scroll disabled (owner 2026-08-18) */; } catch (e) {}
        return;
      }
      try { localStorage.setItem('va_appeal_email', mail); } catch (e) {}
      send.disabled = true; send.textContent = 'Sending…';
      /* body is assembled HERE from the locked facts + their why — the locked
         part never passes through an editable control. */
      var fd = new FormData();
      fd.append('form_type', 'contact');
      fd.append('utf8', '✓');
      fd.append('contact[name]', '⛔ LABEL APPEAL');
      fd.append('contact[email]', mail);
      /* Shopify's notification subject is a fixed template we cannot change,
         so the FIRST body line is the stable marker a Gmail filter keys on. */
      fd.append('contact[subject]', '⛔ Label appeal — ' + termOf(hit));
      fd.append('contact[body]',
        '⛔ BLOCKED-LABEL APPEAL ⛔\n'
        + 'Blocked word: ' + termOf(hit) + '\n'
        + 'Why we blocked it: ' + reasonOnly(hit) + '\n'
        + (opts.value ? ('Customer typed: ' + String(opts.value).slice(0, 200) + '\n') : '')
        + '\nCustomer explanation:\n' + why);
      var meta = collectMeta(hit, opts);
      if (send.dataset.warned) meta['Precedent claim'] = 'yes — customer says it was printed before';
      Object.keys(meta).forEach(function (k) {
        if (meta[k]) fd.append('contact[' + k + ']', String(meta[k]).slice(0, 1200));
      });
      fetch('/contact', { method: 'POST', body: fd })
        .then(function (r) {
          if (!r.ok && r.status !== 302) throw new Error('status ' + r.status);
          h.textContent = 'Review request received'; polref.style.display='none';
          panel.style.display = 'none';
          p.style.display = '';
          p.textContent = 'Your request has been received. A member of our team will review it '
            + 'and reply to ' + mail + ' within 24 business hours.';
          row.style.display = ''; ap.style.display = 'none';
          ok.textContent = 'Close'; ok.dataset.keep = '1';
        })
        .catch(function () {
          /* POST failed (network / bot check) — never dead-end the customer:
             hand off to the prefilled contact page instead. */
          try { window.open(appealUrl(hit, opts), '_blank', 'noopener'); } catch (e) {}
          send.disabled = false; send.textContent = 'Submit for review';
        });
    });

    function wipeErrors() {
      setTimeout(function () {
        try {
          var i, n;
          n = document.querySelectorAll('.va-bad');
          for (i = 0; i < n.length; i++) n[i].classList.remove('va-bad');
          n = document.querySelectorAll('.va-blockmsg');
          for (i = 0; i < n.length; i++) { n[i].style.display = 'none'; n[i].innerHTML = ''; }
          ['vbf-err3', 'vbf-merr', 'va-err', 'va-error'].forEach(function (id) {
            var e = document.getElementById(id);
            if (e) { e.textContent = ''; e.style.display = 'none'; }
          });
          n = document.querySelectorAll('[class*="err"],[id*="err"]');
          for (i = 0; i < n.length; i++) {
            var tx = n[i].textContent || '';
            if (/Please add your|⛔|can’t print|cannot be printed/i.test(tx)
                && n[i].offsetParent !== null) {
              n[i].textContent = ''; n[i].style.display = 'none';
            }
          }
        } catch (e) {}
      }, 30);
    }

    function close() {
      var keep = ok.dataset.keep === '1';   /* appeal sent: leave their text */
      var sx = window.scrollX || window.pageXOffset || 0;
      var sy = window.scrollY || window.pageYOffset || 0;
      var hold = function () { try { window.scrollTo(sx, sy); } catch (e) {} };
      try {
        if (opts.input && !keep) {
          opts.input.value = '';
          opts.input.dispatchEvent(new Event('input', { bubbles: true }));
          opts.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } catch (e) {}
      hold();
      try { requestAnimationFrame(hold); } catch (e) {}
      setTimeout(hold, 40); setTimeout(hold, 150); setTimeout(hold, 420);
      wipeErrors();
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
      openEl = null;
      document.removeEventListener('keydown', onKey, true);
      try {
        if (!isTouch()) {
          var f = opts.input || lastFocus;
          if (f && f.focus) { try { f.focus({ preventScroll: true }); } catch (e2) { f.focus({preventScroll:!0}); } }
        }
      } catch (e) {}
      hold();
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(
        card.querySelectorAll('button,a,input,textarea'),
        function (el) { return el.offsetParent !== null && !el.disabled; });
      if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(i + (e.shiftKey ? f.length - 1 : 1) + f.length) % f.length].focus({preventScroll:!0});
    }
    ok.addEventListener('click', close);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    document.addEventListener('keydown', onKey, true);

    card.appendChild(eyebrow); card.appendChild(h); card.appendChild(chip);
    card.appendChild(p); card.appendChild(polref); card.appendChild(fine); card.appendChild(row);
    card.appendChild(panel);
    wrap.appendChild(card);

    var osx = window.scrollX || window.pageXOffset || 0;
    var osy = window.scrollY || window.pageYOffset || 0;
    document.body.appendChild(wrap);
    var openHold = function () { try { window.scrollTo(osx, osy); } catch (e) {} };
    openHold();
    try { requestAnimationFrame(openHold); } catch (e) {}
    setTimeout(openHold, 50); setTimeout(openHold, 180);
    openEl = wrap;
    if (!isTouch()) { try { ok.focus({ preventScroll: true }); } catch (e) {} }
    return wrap;
  }

  function showDeferred(hit, opts) {
    opts = opts || {};
    var el = opts.input;
    if (!el) return show(hit, opts);
    if (el.__vaT) clearTimeout(el.__vaT);
    var fire = function () {
      if (el.__vaT) { clearTimeout(el.__vaT); el.__vaT = null; }
      el.removeEventListener('blur', fire);
      var v = el.value;
      var again = null;
      try { again = window.vaComplianceHit ? window.vaComplianceHit(v) : hit; } catch (e) { again = hit; }
      if (!again) return;
      show(again, Object.assign({}, opts, { value: v }));
    };
    el.__vaT = setTimeout(fire, 1400);
    el.addEventListener('blur', fire, { once: true });
  }

  window.VA_REFUSAL = { text: text, show: show, showDeferred: showDeferred,
                        appealUrl: appealUrl, reasons: REASONS, warn: WARN,
                        inlineAppeal: true };
})();

/* va-emoji-strip (owner 2026-08-18): emoji are not printable on foil labels —
   the print pipeline renders them as .notdef black squares. Strip them the
   moment they are typed or pasted into any builder field (va-* / vbf-* ids),
   with a brief inline hint. Lives here because va-refusal.js loads site-wide
   BEFORE every builder — one copy covers classic, beta and the wizard. */
(function () {
  var RE;
  try {
    RE = new RegExp('[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}'
      + '\u{FE00}-\u{FE0F}\u{200D}\u{20E3}\u{1F1E6}-\u{1F1FF}]', 'gu');
  } catch (e) {
    RE = /[\uD800-\uDBFF][\uDC00-\uDFFF]|[☀-➿⬀-⯿️‍⃣]/g;
  }
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.id || !/^(va|vbf)-/.test(el.id)) return;
    var tag = (el.tagName || '').toLowerCase();
    if (tag !== 'input' && tag !== 'textarea') return;
    if (el.type && ['text', 'search', 'url', 'tel', 'email', 'textarea', ''].indexOf(el.type) < 0) return;
    var v = el.value;
    if (!v) return;
    var nv = v.replace(RE, '').replace(/  +/g, ' ');
    if (nv === v) return;
    var pos = el.selectionStart;
    el.value = nv;
    try {
      if (pos != null) {
        var np = Math.max(0, pos - (v.length - nv.length));
        el.setSelectionRange(np, np);
      }
    } catch (e2) {}
    try {
      var hint = el.__vaEmojiHint;
      if (!hint) {
        hint = document.createElement('div');
        hint.style.cssText = 'color:#f4b955;font:600 12px/1.4 system-ui;margin:4px 0 0;';
        el.__vaEmojiHint = hint;
        if (el.parentNode) el.parentNode.appendChild(hint);
      }
      hint.textContent = 'Emoji can’t be printed on labels — removed.';
      clearTimeout(hint.__t);
      hint.__t = setTimeout(function () { hint.textContent = ''; }, 2600);
    } catch (e3) {}
  }, true); /* capture: runs before the builder's own listeners, so previews and
               the compliance check always see the cleaned value */
})();

/* va-field-locks REMOVED 2026-08-20 (owner): this capture-phase input listener
   rewrote the field value as you typed - lot to DIGITS ONLY, expiry to date
   characters - across va-lot / vbf-lot / va-exp / va-cexp / vbf-exp, and it
   scrubbed pasted text too. Both are ordinary free-text fields now. Nothing
   protective was here: compliance still screens them at the review gate via
   add('Lot'/'Expiry',...) in vaBlockedFields, which since today also runs the
   medical-claim and Rx/pharmacy lane over identifier fields. The emoji
   stripper above is untouched. */

/* approved-compound allowlist (owner 2026-08-18). HGH / somatropin keys REMOVED 2026-09-23 (owner: "block gh") - vaRestrictedHit below refuses them. */
var VA_COMPOUND_LOOKUP={"retatrutide": "Retatrutide", "tirzepatide": "Tirzepatide", "semaglutide": "Semaglutide", "cagrilintide": "Cagrilintide", "aod9604": "AOD-9604", "5amino1mq": "5-Amino-1MQ", "bpc157": "BPC-157", "tb500": "TB-500", "bpc157tb500": "BPC-157 + TB-500", "ghkcu": "GHK-Cu", "kpv": "KPV", "ss31": "SS-31", "motsc": "MOTS-c", "ipamorelin": "Ipamorelin", "cjc1295": "CJC-1295", "cjc1295ipamorelin": "CJC-1295/Ipamorelin", "sermorelin": "Sermorelin", "tesamorelin": "Tesamorelin", "hexarelin": "Hexarelin", "ghrp2": "GHRP-2", "ghrp6": "GHRP-6", "igf1lr3": "IGF-1 LR3", "semax": "Semax", "selank": "Selank", "dsip": "DSIP", "epithalon": "Epithalon", "thymosinalpha1": "Thymosin Alpha-1", "nad": "NAD+", "glutathione": "Glutathione", "melanotanii": "Melanotan II", "pt141": "PT-141", "kisspeptin": "Kisspeptin", "pe2228": "PE-22-28", "hcg": "HCG", "b12": "B12", "oxytocin": "Oxytocin", "klow": "KLOW", "glow": "GLOW", "wolverine": "Wolverine", "bacteriostaticwater": "Bacteriostatic Water", "reta": "Retatrutide", "retatutride": "Retatrutide", "retatrutied": "Retatrutide", "trizepatide": "Tirzepatide", "tirz": "Tirzepatide", "sema": "Semaglutide", "tesa": "Tesamorelin", "motc": "MOTS-c", "bacwater": "Bacteriostatic Water", "cjcipa": "CJC-1295/Ipamorelin", "melanotan2": "Melanotan II", "mt2": "Melanotan II", "ta1": "Thymosin Alpha-1", "epitalon": "Epithalon", "klow80": "KLOW", "kisspeptin10": "Kisspeptin", "cjc": "CJC-1295", "ipa": "Ipamorelin", "rt": "Retatrutide", "tz": "Tirzepatide", "bpc": "BPC-157", "tb": "TB-500", "ghk": "GHK-Cu", "mots": "MOTS-c", "cagri": "Cagrilintide", "ipam": "Ipamorelin", "slupp332": "SLU-PP-332", "lcarnitine": "L-Carnitine", "miclipoc": "MIC Lipo-C", "cjc1295nodac": "CJC-1295 No DAC", "rta": "Retatrutide", "tsm": "Tesamorelin", "tesamorlin": "Tesamorelin", "tesamoreline": "Tesamorelin", "trizepitide": "Tirzepatide", "tirzepitide": "Tirzepatide", "retratrutide": "Retatrutide", "slupp": "SLU-PP-332", "carnitine": "L-Carnitine", "lipoc": "MIC Lipo-C", "mic": "MIC Lipo-C", "bacteriostatic": "Bacteriostatic Water", "bwater": "Bacteriostatic Water", "impamorllin": "Ipamorelin", "thymosin": "Thymosin Alpha-1", "bac": "Bacteriostatic Water", "bacteriostatich2o": "Bacteriostatic Water", "bacteriowater": "Bacteriostatic Water", "sterilewater": "Bacteriostatic Water", "water": "Bacteriostatic Water", "ahkcu": "AHK-Cu", "melanotani": "Melanotan I", "melatonin": "Melatonin", "cerebrolysin": "Cerebrolysin", "ll37": "LL-37", "vip": "VIP", "gonadorelin": "Gonadorelin", "cartalax": "Cartalax", "pinealon": "Pinealon", "palmitoyltetrapeptide": "Palmitoyl Tetrapeptide", "retta": "Retatrutide", "retatrutride": "Retatrutide", "retratruride": "Retatrutide", "retatruetide": "Retatrutide", "retatruida": "Retatrutide", "redatrutide": "Retatrutide", "r3t": "Retatrutide", "r3ta": "Retatrutide", "trz": "Tirzepatide", "triz": "Tirzepatide", "tizerpitide": "Tirzepatide", "tesamoreln": "Tesamorelin", "cagrilintine": "Cagrilintide", "ipamorelan": "Ipamorelin", "mot": "MOTS-c", "mottc": "MOTS-c", "motcs": "MOTS-c", "mostc": "MOTS-c", "bcp": "BPC-157", "bcp157": "BPC-157", "ghc": "GHK-Cu", "ghccu": "GHK-Cu", "ghucu": "GHK-Cu", "ahk": "AHK-Cu", "elamipretide": "SS-31", "glutathion": "Glutathione", "aod": "AOD-9604", "aod9064": "AOD-9604", "mt1": "Melanotan I", "melanotan1": "Melanotan I", "melatonin2": "Melanotan II", "lipo": "MIC Lipo-C", "5amino": "5-Amino-1MQ", "palmitoyl": "Palmitoyl Tetrapeptide", "t500": "TB-500", "ss": "SS-31", "thymalin": "Thymalin", "ara290": "ARA-290", "dihexa": "Dihexa", "adamax": "Adamax", "pbs": "PBS", "aceticacid": "Acetic Acid", "acetyloctapeptide3": "Acetyl Octapeptide-3", "kisspep": "Kisspeptin", "kisspep10": "Kisspeptin", "ig1lr3": "IGF-1 LR3", "cibinetide": "ARA-290", "pnb0408": "Dihexa", "phosphatebufferedsaline": "PBS", "aceticacidwater": "Acetic Acid", "acetylglutamylheptapeptide1": "Acetyl Octapeptide-3"};window.vaCompoundCheck=function(v){/* OPEN TEXT (owner 2026-08-20): the approved-compound allowlist no longer gates this line. Any custom text is accepted. Trademarks/brands, medical & treatment claims, and Rx/pharmacy-label mimicry are still refused - those run in vaComplianceHit + vaClaimHit, which screen this field independently of the allowlist. Strict behaviour preserved as vaCompoundCheckStrict. */try{var _k=String(v==null?'':v).toLowerCase().replace(/[^a-z0-9]+/g,'');return{ok:true,canon:VA_COMPOUND_LOOKUP[_k]||null};}catch(e){return{ok:true,canon:null};}};window.vaCompoundCheckStrict=function(v){try{var raw=String(v==null?'':v);var n=raw.toLowerCase().replace(/[^a-z0-9]+/g,'');if(!n)return{ok:true,canon:null};if(VA_COMPOUND_LOOKUP[n])return{ok:true,canon:VA_COMPOUND_LOOKUP[n]};/* strength-strip candidates. The original greedy [0-9]+$ ate digits that belong to the NAME ("igf1lr31mg"->"igf1lr"), refusing real products like PT-141 10mg. Try MORE keys, never fewer - additive, so nothing that passes today can start failing. */var _sx=/[\s\-]*[0-9]+(?:[.,][0-9]+)?\s*(?:mg|mcg|ug|ml|cc|iu|units?)\b\.?\s*$/i;var _px=/^\s*[0-9]+(?:[.,][0-9]+)?\s*(?:mg|mcg|ug|ml|cc|iu|units?)\b[\s\-]*/i;var _rawl=raw.toLowerCase();var _nc=[n.replace(/(mg|mcg|ml|iu)$/,'').replace(/[0-9]+$/,'').replace(/(mg|mcg|ml|iu)$/,''),_rawl.replace(_sx,'').replace(/[^a-z0-9]+/g,''),_rawl.replace(_px,'').replace(/[^a-z0-9]+/g,''),_rawl.replace(_px,'').replace(_sx,'').replace(/[^a-z0-9]+/g,''),n.replace(/(?:mg|mcg|ug|ml|cc|iu)$/,''),n.replace(/[0-9]+$/,'')];for(var _ci=0;_ci<_nc.length;_ci++){var _nk=_nc[_ci];if(_nk&&VA_COMPOUND_LOOKUP[_nk])return{ok:true,canon:VA_COMPOUND_LOOKUP[_nk]};}if(n.indexOf('glp')===0||n.indexOf('cjc')===0)return{ok:true,canon:null};/* containment: any token resolving to an approved compound approves the string as typed (brand+compound style). Ester words are separately blocked, so this cannot smuggle oil names. */var ts=raw.toLowerCase().split(/[^a-z0-9]+/);for(var i=0;i<ts.length;i++){var t=ts[i];if(!t)continue;var td=t.replace(/(mg|mcg|ml|iu)$/,'').replace(/[0-9]+$/,'').replace(/(mg|mcg|ml|iu)$/,'');if(VA_COMPOUND_LOOKUP[t]||(td&&VA_COMPOUND_LOOKUP[td])||t.indexOf('glp')===0||t.indexOf('cjc')===0)return{ok:true,canon:null};}return{ok:false,canon:null};}catch(e){return{ok:true,canon:null};}};

/* ===========================================================================
   va-restricted (owner 2026-09-23): "block gh", "block cypinate also",
   "block from entering iu", "block mg/ml which would be oil designation",
   "block sustanon", "block cyp also", "est" (test), "block enanthate too",
   "somatropin", "t e", "te", "t a", "block tren and deca too", then "check
   orders for last 2 months, see what got through, then apply blocks" (the
   steroid shorthand below is what that 60-day check found on real orders).

   window.vaRestrictedHit(text) -> {term, word, kind, category, note} | null
     hgh      human growth hormone: HGH / rHGH / Hgggh / "GH" as a word /
              191aa / 191 amino acid / somatropin family / "(human) growth
              hormone" / GH brand names. 2026-09-24 (#1856 "Growth / 120"):
              an HGH code name that IS the product name - Growth, Hyge(s),
              Kigs, Somat(o), "<colour> Tops", Grow / Kig next to a bare number
              or IU - with nothing but numbers / units / IU / H / hormone /
              human / the / kit around it (Hair Growth, Growth Factor, Grow
              Lab, Growth Labs, Muscle Growth Stack stay allowed). Review
              round: Growth one edit off (Grwth, Groth, Gorwth, Growths),
              in up to 6 pieces (Gr ow th, Gr*wth), Grows, Crecimiento.
              NOT GHK-Cu, GHRP-2/6, GHRH, CJC-1295, Ipamorelin, Sermorelin,
              Tesamorelin, MK-677, IGF-1 LR3, "growth hormone releasing /
              secretagogue", "GH blend" next to a named secretagogue, HGH
              Fragment 176-191 - different compounds (the store's best sellers).
     steroid  cypionate / "cyp"; testosterone and its shorthand ("test" as a
              word - not lab wording such as "test kit / tubes / report", "HPLC
              test", TESTED, Latest - Test C/E/P, TEST250, T E, TE, TE250, T A,
              TA 100 - TA-1 and "TA 10mg" (Thymosin Alpha-1) stay allowed - TRT,
              Vitamin T, C-250); enanthate / undecylenate (bare decanoate /
              propionate / acetate stay allowed - Haloperidol Decanoate);
              sustanon; tren (not trend / Trenton / Tre / tretinoin); deca /
              NPP / Na P (not decade / decapeptide / NAD / nap / NP); boldenone
              / EQ / BU200, masteron / Mast (not master / mast cell), primo,
              anavar / var / oxa, winstrol / winny / Win 50, dbol, tbol,
              anadrol, superdrol, "anabolic(s)", "peps and gear".
              2026-09-24 (owner: "block t250 and other t", "and the word gear",
              "and any misspellings or workaround"): a bare T with a
              testosterone-sized number (T250, T 400, T-300, TT250, T25O, T 2 5 0;
              100-600 in steps of 25, never 500 - "T-500" is how customers misspell
              TB-500), Tes 250, typos of Test next to a dose (Tset / Tets / Tezt /
              Tesr 250), and the word gear itself (Gears, Gearz, G3AR, Ge@r, Geer,
              "G E A R", Ge-ar, the gear emoji, Gearhead). Tes / Tst alone, Tes 10 mg
              (Tesamorelin), T3 / T4, TB-500, Geary, gearbox stay allowed.
     brand   a digit / look-alike spelling (0zempic, Mounjar0) of a drug brand
     company  or manufacturer the site ALREADY blocks (window.VA_BRANDS, when
     dea      the page has it); a controlled substance keeps its DEA reason.
              Plain spellings stay with the brand lane in va-builder2.js.
     iu       international units, however typed ("10 IU", "10iu", "I.U.").
     mgml     mg/mL (oil concentration) in any spelling; plain "mL" is fine.
   2026-09-23 review round: lot / batch / serial codes ("Lot TE-2409", "TC-0012",
   "TE-001 -> TE-120"), URLs and e-mail addresses, lab wording ("HPLC Test",
   "Test Report"), names and phrases (Te Amo, Tu Nguyen, IU Health, T&C, Primo
   Wellness) stay allowed; symbols around a word (|HGH|, !TREN), spaced / split /
   doubled letters, more look-alike alphabets and misspellings are read through.
   ONE matcher for every builder: the classic builder + mobile wizard get it
   through va-builder2.js (in front of the vaComplianceHit chain, OUTSIDE the
   category gate), builder v3 and Bulk Mix call it directly at add to cart.
   Pure text in, no DOM. Every caller fails OPEN if it is missing or throws.
   =========================================================================== */
(function () {
  var AP = '\u2019', LQ = '\u201c', RQ = '\u201d';
  var OWN = Object.prototype.hasOwnProperty;
  var NOTE = {
    hgh: function (x) { return LQ + x + RQ + ' is a restricted growth-hormone product. We can' + AP + 't print labels for it.'; },
    steroid: function (x) { return LQ + x + RQ + ' is a steroid product. We can' + AP + 't print labels for it.'; },
    brand: function (x) { return LQ + x + RQ + ' is a registered pharmaceutical brand name. We can print the generic compound name, but not another company' + AP + 's trademark.'; },
    company: function (x) { return LQ + x + RQ + ' is a pharmaceutical company name. We can' + AP + 't print another manufacturer' + AP + 's name or logo on a label.'; },
    dea: function (x) { return LQ + x + RQ + ' is a controlled substance under the DEA schedules. We can' + AP + 't print labels for scheduled drugs.'; },
    iu: function () { return 'We can' + AP + 't print strengths in IU. Please use mg or mcg.'; },
    mgml: function () { return 'We can' + AP + 't print mg/mL (oil) concentrations. Please give the amount per vial, e.g. 10 mg.'; }
  };
  /* look-alike letters (Cyrillic, Greek, Latin, small capitals, Armenian, Cherokee) folded to Latin */
  var CONF = {
    '\u0430': 'a', '\u0432': 'b', '\u0441': 'c', '\u0434': 'd', '\u0435': 'e', '\u0451': 'e', '\u0433': 'r',
    '\u04bb': 'h', '\u0456': 'i', '\u0458': 'j', '\u043a': 'k', '\u043c': 'm', '\u043e': 'o', '\u0440': 'p',
    '\u0455': 's', '\u0442': 't', '\u0443': 'y', '\u0445': 'x', '\u043f': 'n', '\u0501': 'd', '\u04cf': 'l',
    '\u051b': 'q', '\u051d': 'w', '\u0461': 'w', '\u0460': 'W', '\u03c9': 'w',
    '\u0410': 'A', '\u0412': 'B', '\u0421': 'C', '\u0415': 'E', '\u041d': 'H', '\u0406': 'I', '\u0408': 'J',
    '\u041a': 'K', '\u041c': 'M', '\u041e': 'O', '\u0420': 'P', '\u0405': 'S', '\u0422': 'T', '\u0423': 'Y',
    '\u0425': 'X', '\u04ae': 'Y', '\u04c0': 'I', '\u051a': 'Q', '\u051c': 'W',
    '\u0391': 'A', '\u0392': 'B', '\u0395': 'E', '\u0396': 'Z', '\u0397': 'H', '\u0399': 'I', '\u039a': 'K',
    '\u039c': 'M', '\u039d': 'N', '\u039f': 'O', '\u03a1': 'P', '\u03a4': 'T', '\u03a5': 'Y', '\u03a7': 'X',
    '\u037f': 'J', '\u03b1': 'a', '\u03b2': 'b', '\u03b3': 'y', '\u03b5': 'e', '\u03b7': 'n', '\u03b9': 'i',
    '\u03ba': 'k', '\u03bd': 'v', '\u03bf': 'o', '\u03c1': 'p', '\u03c4': 't', '\u03c5': 'u', '\u03c7': 'x',
    '\u03bc': 'u', '\u03f3': 'j',
    '\u0131': 'i', '\u00f8': 'o', '\u00d8': 'O', '\u0142': 'l', '\u0141': 'L', '\u0111': 'd', '\u0110': 'D',
    '\u0251': 'a', '\u0261': 'g', '\u0269': 'i', '\u025b': 'e', '\u00a5': 'Y',
    '\u1d00': 'A', '\u0299': 'B', '\u1d04': 'C', '\u1d05': 'D', '\u1d07': 'E', '\ua730': 'F', '\u0262': 'G',
    '\u029c': 'H', '\u026a': 'I', '\u1d0a': 'J', '\u1d0b': 'K', '\u029f': 'L', '\u1d0d': 'M', '\u0274': 'N',
    '\u1d0f': 'O', '\u1d18': 'P', '\u0280': 'R', '\ua731': 'S', '\u1d1b': 'T', '\u1d1c': 'U', '\u1d20': 'V',
    '\u1d21': 'W', '\u028f': 'Y', '\u1d22': 'Z',
    '\u0585': 'o', '\u057d': 'u', '\u0570': 'h', '\u0578': 'n',
    '\u13aa': 'A', '\u13f4': 'B', '\u13df': 'C', '\u13a0': 'D', '\u13ac': 'E', '\u13c0': 'G', '\u13bb': 'H',
    '\u13a5': 'i', '\u13ab': 'J', '\u13e6': 'K', '\u13de': 'L', '\u13b7': 'M', '\u13eb': 'O', '\u13e2': 'P',
    '\u13a1': 'R', '\u13da': 'S', '\u13a2': 'T', '\u13d9': 'V', '\u13b3': 'W', '\u13c3': 'Z'
  };
  var LEET = { '0': 'o', '1': 'i', '3': 'e', '4': 'a', '5': 's', '7': 't' };
  var SYM = { '$': 's', '@': 'a', '|': 'i', '!': 'i' };
  var GH_IN = ['genotrop', 'humatrop', 'norditrop', 'omnitrop', 'serostim', 'zomacton', 'nutropin', 'skytrofa',
    'sogroya', 'zorbtive', 'accretropin', 'valtropin', 'tevtropin', 'jintropin', 'hygetropin', 'kigtropin',
    'riptropin', 'ansomone', 'getropin', 'eutropin', 'scitropin', 'growject', 'hypertropin', 'taitropin'];
  /* short: only at the start of ONE word ("Sai Zen Spa" is a spa; "Jintro", "Kigtrop", "Riptro" but
     never Riptide / Jingle) */
  var GH_AT = ['saizen', 'ngenla', 'jintro', 'hygetro', 'kigtro', 'riptro'];
  /* somatropin / somatotropin and their misspellings (Sematropin, Somtropin, soomatropin, somatrpoin) */
  var SOMA = /s[aeo]{1,2}m{1,2}[aeiou]?t{1,2}[aeiou]{0,2}t?r{1,2}[aeiou]{0,2}p|somatrem|somatrogon|somapac/;
  var SOMA_AT = new RegExp('^(?:' + SOMA.source + ')');
  /* "GH" followed by one of these names a DIFFERENT compound (GH-RH, GH-RP-6, GH-RF, "GH releasing") */
  var GH_OK = /^(?:rh|rp|rf|grf|rh1|rp2|rp6|releasing|release|releaser|releases|secretagogues?|inhibiting|inhibitory|inhibitor)$/;
  /* a named GH secretagogue in the same text: "Tesamorelin/Ipamorelin GH blend", "GH Blend (CJC/Ipa)" */
  var SECR = / (?:cjc\d*|ipa|ipamorelin|tesa|tesamorelin|ghrp\d*|ghrh|sermorelin|mk 677|mk677|ibutamoren|hexarelin|hexa) /;
  var CYP = /[cs][iy]p(?:r?i?o|oi|yo|eo|ia|ri|i)n[aei]?t/;
  var CYPW = new RegExp('^' + CYP.source + 'e?s?$');                /* two pieces must spell the WHOLE ester ("Cipi Nathan" is a name) */
  var MGML = [
    /* mg / <volume> mL, mg per mL, mg in 1 mL, mg/mI (a capital I or 1 for the l) */
    /(^|[^a-z])(?:mgs?|milligrams?)\s*(?:[\/\\]|\bper\b|\bin\b|\bover\b|-per-)\s*(?:\d*[.,]?\d+\s*)?(?:(?:ml|m1|m\||mi|cc)(?![a-z])|millilit)/,
    /(^|[^a-z])(?:mgs?|milligrams?)\s*[:|]\s*(?:ml|cc)(?![a-z])/,              /* mg:mL, mg|mL */
    /(^|[^a-z])mgs?\s*[-_.]?\s*(?:ml|cc)(?![a-z])/,                           /* mg mL, mg-mL, mg.mL, mgml */
    /(^|[^a-z])m\s+g\s*[\/\\:|]\s*m\s+l(?![a-z])/                              /* m g / m l */
  ];

  /* steroid names of 6+ letters: found INSIDE a word, after the leet / look-alike
     fold ("Testosterone-E", "SUSTANON250", "Nandr0lone", "b0ldenone", "enanthate") */
  var ST_LONG = ['testosteron', 'testeron', 'trenbolon', 'parabolan', 'finaplix', 'nandrolon', 'durabolin',
    'boldenon', 'equipoise', 'drostanolon', 'masteron', 'methenolon', 'primobolan', 'oxandrolon',
    'stanozolol', 'winstrol', 'methandrostenolon', 'methandienon', 'dianabol', 'turinabol',
    'trestolon', 'oxymetholon', 'anadrol', 'halotestin', 'fluoxymesteron', 'superdrol',
    'sustanon', 'sustenon', 'anabolic', 'enanthat', 'enathat', 'enantat', 'undecylenat',
    'metandienon', 'metandrostenolon', 'methasteron', 'mesterolon', 'proviron'];
  /* the same names split in two ("Testo sterone", "n androlone"): the two words must
     spell the WHOLE name - so "Master One" never reads as masteron */
  var ST_PAIR = ['testosterone', 'trenbolone', 'nandrolone', 'boldenone', 'equipoise',
    'drostanolone', 'masteron', 'methenolone', 'primobolan', 'oxandrolone', 'anavar', 'stanozolol',
    'winstrol', 'dianabol', 'turinabol', 'trestolone', 'oxymetholone', 'anadrol', 'halotestin',
    'superdrol', 'sustanon', 'parabolan', 'durabolin', 'enanthate', 'undecylenate', 'anabolic',
    'anabolics', 'finaplix', 'methandrostenolone', 'fluoxymesterone'];
  /* misspellings: edit distance <= n from the whole name (never a word the store prints -
     parabolan is left out: "parabola" / "parabolic" are one or two edits away) */
  var ST_FUZZ = [['testosterone', 2], ['nandrolone', 2], ['trenbolone', 2], ['stanozolol', 2], ['oxandrolone', 2],
    ['boldenone', 2], ['drostanolone', 2], ['methandienone', 2], ['methandrostenolone', 2], ['durabolin', 2],
    ['turinabol', 2], ['primobolan', 2], ['enanthate', 2], ['oxymetholone', 2], ['trestolone', 2],
    ['halotestin', 2], ['fluoxymesterone', 2], ['undecylenate', 2], ['equipoise', 1], ['sustanon', 1],
    ['dianabol', 1], ['winstrol', 1], ['anabolic', 1], ['superdrol', 1], ['finaplix', 1]];
  var ST_RX = [], ST_RXC = [], ST_WORD = [], ST_PJ = {};
  /* steroid shorthand of 3-5 letters that two pieces may spell: "Tr en", "De ca", "Ma st" */
  var PAIR_SHORT = { tren: 1, deca: 1, sust: 1, sus: 1, mast: 1, primo: 1, test: 1, cyp: 1, npp: 1, hgh: 1, growth: 1, gear: 1, gears: 1 };
  /* test + these words is lab wording, not testosterone ("TEST KIT", "Test Report", "Test #4471") */
  var TEST_OK = /^(?:kits?|batch(?:es)?|tubes?|labels?|articles?|orders?|strips?|results?|runs?|prints?|printing|sheets?|samples?|passed|pass|only|items?|substances?|methods?|plates?|protocols?|portions?|panels?|conditions?|compounds?|controls?|concentrations?|units?|groups?|systems?|reports?|purposes?|id|date|verified|vials?|cards?|labs?|data|instruments?|equipment|certificates?|cert|pending|status|complete|completed|copy|page|mode)$/;
  /* ... and a test named after its method ("HPLC Test", "Third-Party Test", "Pre-Test") */
  var TEST_PV = /^(?:hplc|purity|endotoxin|sterility|lab|labs|coa|janoshik|party|spec|pre|metabolic|sample|identity|potency|stability|microbial|quality|qc|analytical|independent|blood|drug|urine|pregnancy|metals|solvent|solvents|residual|bacterial|dna|pcr|antigen|antibody|mycoplasma|lal|mass)$/;
  /* TE / TC / TP / TU + these is Tris-EDTA, a lab reagent, a phrase or a name, not a steroid */
  var ABBR_OK = /^(?:buffers?|tris|edta|solutions?|reagents?|assays?|standards?|controls?|media|medium|kits?|samples?|stain|dye|saline|diluent|tubes?|strips?|plates?|ph)$/;
  var NAME_FOLLOW = /^(?:wellness|health|clinic|clinics|peptides?|water|family|road|street|avenue|lane|connectivity|link|delft|spa|amo|quiero|adoro|amamos|extrano|verde|negro|whatu|aroha|salud|bienestar|amor|vida|nguyen|tran|pham|huynh|hoang|phan|dang|bui|ngo|duong)$/;
  var T2_PREV = /^(?:para|por|en|de|con|que|no|yo|se|mi)$/;        /* "Para Tu Salud", "no te" */
  var INIT_PREV = /^(?:for|by|from|to|dear|love|dr|mr|mrs|ms|prof)$/;   /* "Made for T.E." */
  var CTX_WORD = /^(?:blend|oil|vial|vials|ester|base|susp|suspension|prop|cyp|enan|depot|injection|injectable|gear|mix|stack|cycle|test)$/;
  var ESTER = /^(?:[ecpu]|cyp|cip|cypionate|enan|enanth|enanthate|prop|propionate|acetate|ace|susp|suspension|undec|undecanoate|base|blend|depot|phenylprop)$/;
  var T_EST = /^(?:prop|propionate|acetate|susp|suspension|undec|undecanoate|enan|enanthate|cyp|cypionate|cip|base)$/;
  /* C-250 is Test Cyp 250 - unless the C belongs to a vitamin / supplement / temperature */
  var C_OK = /^(?:vitamin|vitamins|vitamine|vitamina|vit|lipo|liposomal|mic|mots|mot|motz|most|ascorbic|ester|type|model|glutathione|complex|b12|b6|d3|zinc|and|with|plus)$/;
  var TREN_OK = /^(?:treen|treena|trenna)$/;                       /* a word and first names, not Tren */
  var IU_OK = /^(?:health|hoosiers|university|school|medicine|methodist)$/;   /* IU Health */
  var UNIT = /^(?:mgs?|mcg|ug|mls?|cc|ius?|miu|kiu|g|kg|gm|mm|cm|x|u|units?|k|mo|am|pm|st|nd|rd|th|pcs|pc|pk|ct|oz|lbs?|hrs?|h|d|days?|wks?|mins?|secs?|eq)$/;
  var LOTW = /^(?:lot|lots|batch|batches|bn|sn|serial|serials|seal|seals|code|codes|ref|sku|coa|cert|mfg|id)$/;
  var LOTW2 = /^(?:no|nr|num|number|id|code)$/;
  var URLRX = /(?:https?:\/\/|www\.)[^\s]+|[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}|\b[A-Za-z0-9-]{3,}(?:\.[A-Za-z0-9-]+)*\.(?:com|net|org|io|co|us|me|info|biz|shop|store|bio|ca|uk|de|au|app|dev|xyz|online|site|club|health|care|link|ly|gg|tv)\b(?:\/[^\s]*)?/g;
  var SQL = /\ud83c([\udd30-\udd49\udd50-\udd69\udd70-\udd89])/g;   /* squared / negative-circled letters */

  function emailAt(s, i) {
    return /[A-Za-z0-9._%+-]$/.test(s.slice(Math.max(0, i - 1), i)) && /^[A-Za-z0-9-]+\.[A-Za-z]{2,}/.test(s.slice(i + 1, i + 80));
  }
  /* mode 0: $ @ | ! next to a letter, in a word of 3+ letters, read as s a i i ("te$t", "Mounj@ro", "Dec@", "dbo|");
     mode 1: every $ @ | ! is a separator ("|HGH|", "!TREN", "T|R|E|N") */
  function prep(v, mode) {
    var s = String(v == null ? '' : v).slice(0, 5000);
    s = s.replace(/\u2699/g, ' gear ')                                 /* the gear emoji is steroid slang */
      .replace(/[\u2120\u2122]/g, ' ')                                  /* TM / SM signs: NFKD would glue "TM" onto the word */
      .replace(SQL, function (x, lo) { return String.fromCharCode(65 + ((lo.charCodeAt(0) - 0xdd30) & 31)); })
      .replace(/(?:\ud83c[\udde6-\uddff]){2}/g, ' ')                   /* a flag (two regional indicators) */
      .replace(/\ud83c([\udde6-\uddff])/g, function (x, lo) { return String.fromCharCode(65 + lo.charCodeAt(0) - 0xdde6); })
      .replace(/[\u03f2\u03f9]/g, function (c) { return c === '\u03f9' ? 'C' : 'c'; });   /* lunate sigma, before NFKD */
    try { s = s.normalize('NFKD'); } catch (e) {}
    s = s.replace(/[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/g, '')
      .replace(/[\u00ad\u034f\u061c\u115f\u1160\u17b4\u17b5\u180b-\u180e\u200b-\u200f\u202a-\u202e\u2060-\u2069\u2800\u3164\ufe00-\ufe0f\ufeff\uffa0]|\udb40[\udc00-\udc7f\udd00-\uddef]|\ud834[\udd73-\udd7a]/g, '')
      .replace(/[\u0660-\u0669]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0x0630); })
      .replace(/[\u06f0-\u06f9]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0x06c0); })
      .replace(/[^\x00-\x7f]/g, function (c) { return OWN.call(CONF, c) ? CONF[c] : c; })
      .replace(/[\u2044\u2215\u2571\u29f8\uff0f\u00f7]/g, '/')
      .replace(/([A-Za-z])\u20ac(?=[A-Za-z])/g, '$1e')
      .replace(/[\ud83c-\ud83e][\udc00-\udfff]|[\u2600-\u27bf\u2b00-\u2bff]/g, ' ');   /* other emoji */
    if (mode) return s.replace(/[$@|!]/g, function (c, i) { return (c === '@' && emailAt(s, i)) ? c : ' '; });
    return s.replace(/[A-Za-z0-9$@|!]+/g, function (w, off) {
      if (!/[$@|!]/.test(w) || (w.match(/[A-Za-z]/g) || []).length < 3) return w;
      return w.replace(/[$@|!]/g, function (c, p) {
        if (c === '@' && emailAt(s, off + p)) return c;
        return (/[A-Za-z]/.test(w.charAt(p + 1)) || /[A-Za-z]/.test(w.charAt(p - 1))) ? SYM[c] : c;
      });
    });
  }
  function leet(t) {
    return /[a-z][^a-z]*[a-z][^a-z]*[a-z]/.test(t) ? t.replace(/[013457]/g, function (c) { return LEET[c]; }) : t;
  }
  /* leet + the look-alike letter pairs (rn = m, l = i) - applied to BOTH sides of a name match */
  function fold(t) {
    return leet(t).replace(/rn/g, 'm').replace(/l/g, 'i');
  }
  function rep(t) { return t.replace(/([a-z])\1+/g, '$1'); }       /* "Susstanon", "Ttren", "Deeca" */
  function nLet(t) { return (t.match(/[a-z]/g) || []).length; }
  /* edit distance <= k (banded, early exit) */
  function lev(a, b, k) {
    var la = a.length, lb = b.length, i, j;
    if (Math.abs(la - lb) > k) return false;
    var prev = [], cur;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur = [i]; var best = i;
      for (j = 1; j <= lb; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
        if (cur[j] < best) best = cur[j];
      }
      if (best > k) return false;
      prev = cur;
    }
    return prev[lb] <= k;
  }
  ST_LONG.forEach(function (n) {
    var tail = n === 'masteron' ? '(?!i)' : '';                      /* not "masteronline" */
    ST_RX.push(new RegExp(fold(n) + tail));
    ST_RXC.push(new RegExp(rep(fold(n)) + tail));
    ST_WORD.push(n);
  });
  ST_RX.push(new RegExp('^' + fold('anavar'))); ST_RXC.push(new RegExp('^' + rep(fold('anavar'))));
  ST_WORD.push('anavar');                                            /* start only: "canavar" */
  ST_PAIR.forEach(function (n) { ST_PJ[fold(n)] = n; });

  /* digit / look-alike spellings of the brands the site ALREADY blocks (window.VA_BRANDS,
     va-builder2.js). Built once per list, read at call time; no list = lane off. */
  var BF = null, BFC = null, BFsrc = null;
  var FUZZ_BRANDS = ['ozempic', 'mounjaro', 'zepbound', 'trulicity', 'rybelsus', 'saxenda', 'victoza'];
  function brandFold() {
    var B = window.VA_BRANDS;
    if (!B || typeof B !== 'object') return null;
    if (BFsrc !== B) {
      var m2 = {}, m3 = {};
      for (var key in B) {
        if (!OWN.call(B, key) || !/^[a-z]{5,}$/.test(key)) continue;
        var fk = fold(key);
        if (!OWN.call(m2, fk)) m2[fk] = key;
        if (rep(fk).length >= 6 && !OWN.call(m3, rep(fk))) m3[rep(fk)] = key;
      }
      BF = m2; BFC = m3; BFsrc = B;
    }
    return BF;
  }
  function clean(x) {
    return String(x).replace(/[<>&"'`]/g, '').replace(/\s+/g, ' ').trim().slice(0, 40);
  }
  function hit(cat, term, word) {
    term = clean(term) || String(word);
    return { term: term, word: String(word), kind: 'restricted', category: cat,
             note: NOTE[cat](term), restricted: true, suggest: '' };
  }

  /* ---- context: doses, lot / serial codes, URLs ---- */
  function numTok(t) { return /^\d+$/.test(t || ''); }
  /* a steroid dose: 10-600 (or [min, max]), a multiple of 5, no leading zero ("0925", "726", "2409" are codes) */
  function doseN(d, min, max) {
    if (!/^[1-9]\d{1,3}$/.test(d)) return false;
    var n = +d;
    return n >= (min || 10) && n <= (max || 600) && n % 5 === 0;
  }
  function doseTok(t, min, max) { var d = /^(\d{2,4})(?:mgs?)?$/.exec(t || ''); return !!d && doseN(d[1], min, max); }
  /* a testosterone-sized number behind a bare T / Tes: 100-600 in steps of 25 (T250, T 400). no500: TB-500
     is typed "T-500" (#1420 "BCP-157 / T-500") */
  function tDoseN(d, no500) {
    if (!/^[1-6]\d{2}$/.test(d)) return false;
    var n = +d;
    return n >= 100 && n <= 600 && n % 25 === 0 && !(no500 && n === 500);
  }
  function tDoseAt(T, n, no500) {                                    /* "T 250", "T-250mg" - never "T 250 mcg" */
    var d = T[n] && /^(\d{3})(?:mgs?)?$/.exec(T[n].t);
    return !!d && tDoseN(d[1], no500) && !(T[n + 1] && /^(?:mcg|ug)$/.test(T[n + 1].t));
  }
  function doseAt(T, n, min, max) {                                  /* "100 mcg" is not a steroid dose */
    if (!T[n] || !doseTok(T[n].t, min, max)) return false;
    return !(numTok(T[n].t) && T[n + 1] && /^(?:mcg|ug)$/.test(T[n + 1].t));
  }
  function stAfter(T, n) {                                           /* a dose or an ester in the next 3 words */
    for (var q = n; q < n + 3 && q < T.length; q++) if (ESTER.test(T[q].t) || doseAt(T, q)) return true;
    return false;
  }
  function lotCtx(T, k) {                                            /* "Lot TE-2409", "SN TP0042", "Lot No. TE-01" */
    if (k > 0 && LOTW.test(T[k - 1].t)) return true;
    return k > 1 && LOTW2.test(T[k - 1].t) && LOTW.test(T[k - 2].t);
  }
  function gl(C, a, b) { return /^[-_]?$/.test(C.s.slice(C.T[a].j, C.T[b].i)); }
  /* the shorthand T[a..b] is part of a lot / serial / URL, not a product name */
  function coded(C, a, b) {
    var T = C.T, nx = T[b + 1];
    if (C.X[a]) return true;
    if (nx && numTok(nx.t)) {
      if (lotCtx(T, a) || !doseN(nx.t)) return true;                 /* "Lot TE 250", "TE-2409", "TC 99" */
      if (gl(C, b, b + 1) && C.P[T[a].t]) return true;              /* "TE-001 -> TE-120" */
    }
    return a > 0 && /\d/.test(T[a - 1].t) && /^[-_.\/]$/.test(C.s.slice(T[a - 1].j, T[a].i));   /* "L2409-TE" */
  }
  function codedMix(C, a, lt, d) {                                   /* one token: "TE2409", "Lot:ta126" */
    return !!C.X[a] || lotCtx(C.T, a) || !doseN(d) || !!C.P[lt];
  }
  function nameCoded(C, a, b) {                                      /* "DECA-77": a name glued to a code number */
    var nx = C.T[b + 1];
    return !!C.X[a] || (!!nx && numTok(nx.t) && /^[-_]$/.test(C.s.slice(C.T[b].j, nx.i)) && !doseN(nx.t));
  }
  /* single letters read as initials, not shorthand: "T.C. Wellness", "Made for T.E.", "T. E. Lawrence" */
  function initialsOk(C, u, strict) {
    var T = C.T, a = u.a, b = u.b, nx = T[b + 1] ? T[b + 1].t : '', pv = T[a - 1] ? T[a - 1].t : '', z, dotted = true;
    if (stAfter(T, b + 1)) return false;
    for (z = a; z <= b; z++) if (C.s.charAt(T[z].j) !== '.') dotted = false;
    if (strict && !dotted) return false;
    if (INIT_PREV.test(pv) || ABBR_OK.test(nx) || NAME_FOLLOW.test(nx)) return true;
    return dotted && !!T[b + 1] && /^[A-Z][a-z]{2,}$/.test(T[b + 1].o) && !CTX_WORD.test(nx);
  }
  function cOwned(C, a) {                                            /* the C of a vitamin, not Test Cyp */
    var T = C.T;
    if (C.X[a] || lotCtx(T, a)) return true;
    if (a > 0) {
      var sp = C.s.slice(T[a - 1].j, T[a].i);
      if (!/\s/.test(sp) || /[+&,]/.test(sp) || numTok(T[a - 1].t)) return true;   /* MOTS-C, "+ C 300", "4 C" */
    }
    for (var p = a - 1; p >= 0 && p >= a - 3; p--) if (C_OK.test(T[p].t)) return true;
    return false;
  }

  function ghWord(C, u) {
    var T = C.T, t = u.t, lt = leet(t), a = u.a, b = u.b, run = a < b && !u.p, i;
    var nx = T[b + 1] ? T[b + 1].t : '', n2 = T[b + 2] ? T[b + 2].t : '', n3 = T[b + 3] ? T[b + 3].t : '';
    if (/^r?h+[g9]+h+/.test(t)) {                                    /* also "Hgggh", "H9H" */
      return !(/^frag(?:ment)?s?$/.test(nx) && (n2 === '176' || n3 === '176'));   /* HGH Frag 176-191 (AOD's parent) */
    }
    if (t === 'gh') {
      if (C.X[a] || GH_OK.test(nx) || (nx === 'k' && n2 === 'cu')) return false;   /* GH-RH, GH-K-Cu */
      if (run ? initialsOk(C, u, true) : (coded(C, a, b) && !(numTok(nx) && nx.length < 3 && nx.charAt(0) !== '0'))) return false;
      return !(C.secr && !/^\d/.test(nx) && !/^(?:iu|ius|mg|mcg)$/.test(nx));
    }
    if (/^gh(?:\d{1,3}(?:iu|ius|mg)|191aa?)$/.test(t) || /^191aa/.test(t)) return true;
    if (SOMA.test(t) || SOMA.test(lt)) return true;
    for (i = 0; i < GH_IN.length; i++) if (t.indexOf(GH_IN[i]) >= 0 || lt.indexOf(GH_IN[i]) >= 0) return true;
    if (a === b && !u.p) for (i = 0; i < GH_AT.length; i++) if (t.indexOf(GH_AT[i]) === 0 || lt.indexOf(GH_AT[i]) === 0) return true;
    return false;
  }
  /* 2026-09-24 (#1856): #1852 "GH / 120 IU" was refused and cancelled; 9 hours later the same design,
     lot and expiry came back as "Growth / 120" (unit Custom..., left empty). Owner: "block it", "we do
     not allow etc". An HGH code name that IS the product name - the word with nothing around it but
     numbers, units, IU, "H", "hormone", "human", "the", "kit" - is growth hormone: "Growth", "GROWTH
     120", "Gr0wth 10iu", "the growth", "G R O W T H", "Growth H", "Hyges", "Kigs 100iu", "Somato",
     "Blue Tops", "Green Top 100iu". Any other word keeps it allowed: Hair Growth, Growth Factor,
     IGF-1 (growth factor), Growth Hormone Releasing Peptide, GHRP-6 growth, Muscle Growth Stack,
     Grow Lab, Growth Labs, Hygiene, Hygge, "Blue top vial". "Grow" and "Kig" (a word / initials)
     also need a bare number, IU or H right next to them ("Grow 120", "Kig 100iu"): "Grow" alone and
     "Grow 10mg" read like a GLOW / KLOW house-blend name. Bare Jin / Rips / Greys are NOT names here:
     Jin is a given name and a K-pop idol, rips / RIPHITS / Riptide are card-break words (Serial Seal). */
  /* 2026-09-24 review: Growth within ONE edit (Grwth, Groth, Growh, Gorwth, Growths, "Gr@wth" =
     Grawth, "Grovvth"), spelled across up to 6 pieces ("Gr ow th", "Gr-ow-th", "GRO W TH", "Gr*wth",
     "Gr()wth"), Grows next to a number, Crecimiento / Crescimento / Crescita / Croissance / Wachstum
     (growth in Spanish, Portuguese, Italian, French, German), and "No. 120"
     / "x10" as filler. The whole-field rule is unchanged: any other word keeps it allowed. */
  var GN_ALONE = /^(?:growth|growht|grwoth|hyges?|kigs|somat|somato|somatro|crecimiento|crescimento|crescita|croissance|wachstum)$/;
  var GN_NEAR = /^(?:grow|grows|kig)$/;
  var GN_TOPS = /^(?:blue|green|red|black|grey|gray|yellow|purple|white)$/;
  var GN_NOISE = /^(?:h|hormones?|horm|hormon|harmones?|human|the|kits?)$/;
  function gnGrowth(x) {                                             /* growth, or one letter changed / added / dropped / swapped */
    if (x === 'growth') return true;
    if (x.length < 5 || x.length > 7 || !/^[a-z]+$/.test(x)) return false;
    if (lev(x, 'growth', 1)) return true;
    for (var i = 0; i + 1 < x.length; i++) if (x.slice(0, i) + x.charAt(i + 1) + x.charAt(i) + x.slice(i + 2) === 'growth') return true;
    return false;
  }
  function gnKind(w) {                                               /* 1: the name alone is enough; 2: Grow / Grows / Kig need a number */
    var lw = leet(w.replace(/[69]/g, 'g')), rw = rep(lw);
    if (GN_ALONE.test(lw) || gnGrowth(rw)) return 1;
    if (GN_NEAR.test(lw) || rw === 'grow' || rw === 'grows') return 2;
    return 0;
  }
  function gnNoise(T, k) {                                           /* 120, 10iu, 24 IU, I.U., mg, H, the, kit, x10, No. 120 */
    var t = T[k].t, m = /^\d+([a-z]*)$/.exec(t);
    if (m) return !m[1] || UNIT.test(m[1]);
    if (/^x\d+$/.test(t)) return true;
    if (/^(?:no|nr|num|number)$/.test(t)) return !!T[k + 1] && /^\d/.test(T[k + 1].t);
    return UNIT.test(t) || GN_NOISE.test(t) || (t === 'i' && !!T[k + 1] && T[k + 1].t === 'u');
  }
  /* a bare dose-sized number (1-999, not "10 mg", not a year / code such as 2026 or 0120), IU, H, hormone */
  function gnSig(T, k) {
    if (k < 0 || k >= T.length) return false;
    var t = T[k].t, nx = T[k + 1] ? T[k + 1].t : '', pv = k > 0 ? T[k - 1].t : '';
    if (/^\d+$/.test(t)) return /^[1-9]\d{0,2}$/.test(t) && !/^(?:mgs?|mcg|ug|g|mls?|cc)$/.test(nx);
    return /^\d*[mk]?ius?$/.test(t) || (t === 'i' && nx === 'u') || (t === 'u' && pv === 'i') ||
           /^(?:h|hormones?|horm|hormon|human)$/.test(t);
  }
  function ghName(C, U) {
    var T = C.T, i, k, u, m, w, lw, kind, sig, a, b, z, jw, V = U.slice();
    /* Growth in 2-6 pieces with 1-3 symbols (never a newline or &) between them: "Gr ow th",
       "Gr-ow-th 120", "GRO W TH", "Gr*wth", "Gr()wth" - only ever read as growth, nothing else */
    for (k = 0; k + 1 < T.length; k++) {
      if (!/[a-z]/.test(T[k].t) || C.X[k]) continue;
      for (jw = T[k].t, z = k + 1; z < T.length && z <= k + 5; z++) {
        if (!/[a-z]/.test(T[z].t) || !/^[^A-Za-z0-9&\n]{1,3}$/.test(C.s.slice(T[z - 1].j, T[z].i))) break;
        jw += T[z].t;
        if (jw.length > 9) break;
        if (/^[a-z0-9]+$/.test(jw) && gnGrowth(rep(leet(jw.replace(/[69]/g, 'g'))))) { V.push({ t: jw, a: k, b: z, p: 1 }); break; }
      }
    }
    for (i = 0; i < V.length; i++) {
      u = V[i]; a = u.a; b = u.b; w = u.t; sig = false;
      if (C.X[a] || !/^[a-z0-9]+$/.test(w)) continue;
      m = /^([a-z][a-z0-9]*?[a-z])(\d{1,4})([a-z]*)$/.exec(w);        /* glued: "GROWTH120", "Kigs10iu", "Grow10mg" */
      if (m && a === b && !u.p && (!m[3] || UNIT.test(m[3]))) {
        w = m[1];
        sig = m[3] ? /^[mk]?ius?$/.test(m[3]) : /^[1-9]\d{0,2}$/.test(m[2]);
      } else if (u.p && a === b && /^\d/.test(T[a].t)) sig = true;   /* "120Grow" */
      lw = leet(w.replace(/[69]/g, 'g'));
      kind = gnKind(w);
      if (!kind) continue;
      if (C.P[lw]) continue;                                         /* "KIG-2409", "KIGS0012": a serial */
      for (k = 0; k < T.length; k++) if ((k < a || k > b) && !gnNoise(T, k)) break;
      if (k < T.length) continue;
      if (kind === 2 && !sig && !gnSig(T, b + 1) && !gnSig(T, a - 1)) continue;
      return [a, b, rep(lw)];
    }
    /* "Blue Tops", "Green-Top 100iu", "GreyTops" (not the glued word "Blacktop") */
    for (k = 0; k < T.length; k++) {
      var e = -1, z;
      if ((m = /^([a-z]+?)(tops?)$/.exec(T[k].t)) && GN_TOPS.test(m[1]) && m[1] !== 'black') e = k;
      else if (GN_TOPS.test(T[k].t) && T[k + 1] && /^tops?$/.test(T[k + 1].t)) e = k + 1;
      if (e < 0 || C.X[k]) continue;
      for (z = 0; z < T.length; z++) if ((z < k || z > e) && !gnNoise(T, z)) break;
      if (z === T.length) return [k, e, 'tops'];
    }
    return null;
  }
  function cypWord(C, u) {
    var t = u.t, lt = leet(t), a = u.a, b = u.b;
    if (CYP.test(rep(t)) || CYP.test(rep(lt))) return true;          /* cypionate + typos */
    if (/^[a-z]+$/.test(t) && t.length >= 7 && t.length <= 11 && lev(rep(t), 'cypionate', 1)) return true;
    if (C.X[a]) return false;
    if (/^[cs]ypi|^cipio/.test(rep(t))) return true;                 /* Cypi, Cypio, Cypion */
    if (/^(?:test|tst)?c+[iy]+p+(?:\d{2,4}(?:mg|ml)?)?$/.test(t)) return a < b || !coded(C, a, b);   /* cyp, cip, Cyyp */
    return false;
  }
  function iuWord(C, u) {
    var T = C.T, t = u.t, a = u.a, b = u.b, nx = T[b + 1] ? T[b + 1].t : '';
    if (/\d[mk]?ius?$/.test(t)) return true;                         /* 10iu, 5000IU, 25mIU */
    if (/^[mk]ius?$/.test(t)) return a > 0 && numTok(T[a - 1].t);    /* 25 mIU - never the name Miu */
    if (!/^ius?$/.test(t)) return false;
    if (IU_OK.test(nx) || C.X[a]) return false;                      /* IU Health */
    if (a === b && nx && numTok(nx) && /^-?$/.test(C.s.slice(T[b].j, T[b + 1].i))) return false;   /* IU-2409 is a code */
    return !(a === b && coded(C, a, b) && lotCtx(T, a));
  }

  /* one word (or one run of single letters, or two pieces of one name) -> [first token, last token, word] | null */
  function steroidWord(C, u) {
    var T = C.T, w = u.t, a = u.a, b = u.b, run = a < b && !u.p, m;
    var nx = T[b + 1] ? T[b + 1].t : '', n2 = T[b + 2] ? T[b + 2].t : '', n3 = T[b + 3] ? T[b + 3].t : '';
    var pv = T[a - 1] ? T[a - 1].t : '', lw = leet(w), fw = fold(w), cw = rep(w), clw = rep(lw), q;
    if (!C.X[a]) {
      /* testosterone: "test" as a whole word, unless it is lab wording */
      if (w === 'test' || w === 'testo' || lw === 'test' || lw === 'testo' || cw === 'test' || clw === 'test' ||
          (/^[t7][e3][s5][t7]$/.test(w) && nLet(w) >= 2)) {
        var lab = TEST_OK.test(nx), okw = lab || TEST_PV.test(pv) || (numTok(nx) && !doseN(nx, 10, 1000)) ||
                  (nx === 'do' && n2 === 'not' && n3 === 'ship') || nameCoded(C, a, b);
        if (okw && !stAfter(T, b + (lab ? 2 : 1))) return null;
        return [pv === 'super' ? a - 1 : a, b, 'test'];
      }
      if ((m = /^supertest(\d{2,4}(?:mgs?)?)?$/.exec(w))) return [a, b, 'test'];
      /* 2026-11-01 (#2334 "BIOHACK TEST250C" / "T250C" printed): the ester may also FOLLOW the number - TEST250C, TEST400E */
      m = /^t[e3][s5](?:t|7(?!\d))[o0]?(c|e|p|u|cyp|cip|en|enan|eth|prop|susp|base|blend)?(\d{2,4}(?:mgs?)?)?(c|e|p|u|cyp|cip|en|enan|eth|prop|susp)?$/.exec(cw);
      if (m && (m[1] || m[2]) && (!m[3] || m[2]) && (!m[2] || doseTok(m[2], 10, 1000))) return [a, b, 'test'];
      if (/^t[e3][s5]t[o0]s/.test(cw)) return [a, b, 'test'];          /* Testos, Testost, Testoster */
      if (w === 'tst' && (ESTER.test(nx) || doseAt(T, b + 1))) return [a, b + 1, 'test'];
      if (w === 'tes' && /^[ecpu]$/.test(nx) && doseAt(T, b + 2, 50)) return [a, b + 2, 'test'];
      /* T E / T C / T P / T U spelled out, bare TE TC TP TU, glued TE250 / TCYP */
      if (/^t[ecpu]$/.test(w)) {
        if (w === 'tp' && /^508/.test(nx)) return null;               /* TP-508 peptide */
        if (run ? initialsOk(C, u, false) : coded(C, a, b)) return null;
        if ((ABBR_OK.test(nx) || NAME_FOLLOW.test(nx)) && !stAfter(T, b + 2)) return null;
        if (!run && (T2_PREV.test(pv) || /^(?:dr|mr|mrs|ms|prof)$/.test(pv)) && !stAfter(T, b + 1)) return null;
        /* a name or a phrase, not shorthand: "Te Anau", "Tu Anh", "Tu & Yo" (Title-case, then a Title-case word) */
        if (!run && /^[A-Z][a-z]$/.test(T[a].o) && T[b + 1] && /^[A-Z][a-z]+$/.test(T[b + 1].o) && !CTX_WORD.test(nx) &&
            !stAfter(T, b + 2)) return null;
        return [a, b, w];
      }
      if ((m = /^7([ecpu])$/.exec(w)) && doseAt(T, b + 1)) return [a, b + 1, 't' + m[1]];
      if ((m = /^[t7]([ecpu])(\d{2,4})(?:mgs?)?$/.exec(w)) && !codedMix(C, a, 't' + m[1], m[2])) return [a, b, w];
      if (/^tcyp(?:\d{2,4}(?:mgs?)?)?$/.test(w)) return [a, b, w];
      /* T A spelled out; TA only with a steroid dose of 50+ - TA-1 / TA 10mg / T.A. 10mg is Thymosin Alpha-1 */
      if (w === 'ta') {
        if (run) {
          if (nx && /^\d/.test(nx)) return doseAt(T, b + 1, 50) ? [a, b + 1, 'ta'] : null;
          return initialsOk(C, u, false) ? null : [a, b, 'ta'];
        }
        return (doseAt(T, b + 1, 50) && !coded(C, a, b)) ? [a, b + 1, 'ta'] : null;
      }
      if ((m = /^[t7]a(\d{2,4})(?:mgs?)?$/.exec(w)) && doseN(m[1], 50) && !codedMix(C, a, 'ta', m[1])) return [a, b, 'ta'];
      if (w === '7a' && doseAt(T, b + 1, 50)) return [a, b + 1, 'ta'];
      if (w === 't' && !run) {
        if (nx === 'en' || /^bo[l1i]$/.test(nx)) return [a, b + 1, nx === 'en' ? 'ten' : 'tbol'];   /* "t en", "T-bol" */
        if (T_EST.test(nx)) return [a, b + 1, 't' + nx];               /* "T-Prop", "T Acetate" */
        /* 2026-09-24 (owner: "block t250 and other t"): T 250, T-400, T.300, T/200, "T 2 5 0" */
        if (tDoseAt(T, b + 1, 1) && /^[\s._\/\\~:*-]*$/.test(C.s.slice(T[b].j, T[b + 1].i)) && !coded(C, a, b))
          return [a, b + 1, 't' + T[b + 1].t.replace(/mgs?$/, '')];
      }
      /* glued: T250, TT250, T25O ("O" read as a zero by the tokenizer), T400mg - not a serial ("Lot T250",
         "T0012 ... T250") */
      if ((m = /^t+(\d{3})(?:mgs?)?(?:c|e|p|u|cyp|cip|en|enan|eth|prop|susp)?$/.exec(cw)) && tDoseN(m[1], 1) && !codedMix(C, a, 't', m[1])) return [a, b, 't' + m[1]];   /* + T250C / T200E (#2334) */
      /* Tes (not Tesamorelin at 100+ mg) and the typos of Test (Tset, Tets, Tezt, Tesr) next to a dose */
      if (w === 'tes' && !run && tDoseAt(T, b + 1) && !coded(C, a, b)) return [a, b + 1, 'tes'];
      if ((m = /^tes(\d{3})(?:mgs?)?$/.exec(w)) && tDoseN(m[1]) && !codedMix(C, a, 'tes', m[1])) return [a, b, 'tes'];
      if (/^(?:tset|tets|tezt|tesr|tedt|twst|tsst|tetst|testr)$/.test(cw) && !run && (stAfter(T, b + 1) || T.length === 1))
        return [a, b, 'test'];
      /* 2026-09-24 (owner: "and the word gear", "and any misspellings or workaround"): gear is steroid slang -
         Gear, GEARS, Gearz, Geear, G3AR, Ge4r, 6ear, Ge@r, Geer, Gaer, "G E A R", "Ge-ar", Gearhead(z) (#1681 lot
         "GEARHEADZ"), the gear emoji (prep() spells it out). Geary, gearbox, gearing, Gera stay allowed. */
      var gw = w.replace(/[69]/g, 'g').replace(/3/g, 'e').replace(/4/g, 'a');
      if (nLet(w) >= 2 && (/^g+e+a+r+(?:s|z|h[e3]+a?d+[sz]?)?$/.test(gw) || /^g(?:ee|ae)rs?$/.test(gw))) return [a, b, 'gear'];
      if (w === 'd' && !run && /^bo[l1i]$/.test(nx)) return [a, b + 1, 'dbol'];
      if ((m = /^tace(\d{2,4})?(?:mgs?)?$/.exec(w)) && (m[1] ? doseN(m[1], 50) : doseAt(T, b + 1, 50))) return [a, b, 'tace'];
      if (/^vit(?:amin[ae]?)?$/.test(w) && nx === 't') return [a, b + 1, 'vitamint'];
      if (/^vitamin[ae]?t(?:\d{2,4}(?:mgs?)?)?$/.test(w)) return [a, b, 'vitamint'];
      if (/^[t7]rt(?:\d{2,4}(?:mgs?)?)?$/.test(w)) return [a, b, 'trt'];
      if (w === 'c' && !run && T[b + 1] && /^(?:200|250|300|400)(?:mgs?)?$/.test(nx) &&
          /^[\s._-]*$/.test(C.s.slice(T[b].j, T[b + 1].i)) && !cOwned(C, a)) return [a, b + 1, 'c' + nx];
      if (/^c(?:200|250|300|400)(?:mgs?)?$/.test(w) && !cOwned(C, a)) return [a, b, w];
      /* trenbolone: tren / Tren200 / Trenb / Tr3n / TrenA100 / Tr A / TrA 100 (not trend, Trenton, Tre, Treen) */
      if ((/^[t7]ren(?:a|e|h|ace|acetate|hex)?(?:\d{2,4}(?:mgs?)?)?$/.test(cw) ||
           /^[t7]ren(?:a|e|h|ace|acetate|hex)?(?:\d{2,4}(?:mgs?)?)?$/.test(clw) || /^[t7]r[e3]nb/.test(w)) &&
          !TREN_OK.test(w) && !nameCoded(C, a, b)) return [a, b, 'tren'];
      if (w === 'tr' && /^(?:a|e|h|ace)$/.test(nx)) return [a, b + 1, 'tr' + nx];
      if ((m = /^tr[ae](\d{2,4})(?:mgs?)?$/.exec(w)) && !codedMix(C, a, w.slice(0, 3), m[1])) return [a, b, w];
      if ((w === 'tra' || w === 'tre') && doseAt(T, b + 1, 25) && !coded(C, a, b)) return [a, b + 1, w];
      /* nandrolone: deca / Decca / Deka / Dec4 / Deca300, NPP, Na P (not decade / decapeptide / decanoate / NAD / nap / NP) */
      if (/^d[e3][ck][a4](?:\d{2,4}(?:mgs?)?)?$/.test(cw) || /^d[e3][ck][a4](?:\d{2,4}(?:mgs?)?)?$/.test(clw)) {
        return (/^peptides?$/.test(nx) || nameCoded(C, a, b)) ? null : [a, b, 'deca'];
      }
      if (/^n+p{2,}(?:\d{2,4}(?:mgs?)?)?$/.test(w)) return [a, b, 'npp'];
      if (w === 'na' && nx === 'p') return [a, b + 1, 'nap'];
      /* boldenone (EQ, BU200), masteron (Mast, Ma E), primobolan (primo, Pr E), anavar (var, oxa),
         winstrol (winny, Win 50), dianabol / turinabol (dbol, tbol) */
      if ((m = /^eq(\d{2,4})?(?:mgs?)?$/.exec(w)) && !(m[1] ? codedMix(C, a, 'eq', m[1]) :
          (coded(C, a, b) || numTok(pv) || /^(?:equivalents?|equiv|molar)$/.test(pv)))) return [a, b, 'eq'];
      if ((m = /^bu(\d{2,4})(?:mgs?)?$/.exec(w)) && !codedMix(C, a, 'bu', m[1])) return [a, b, 'bu'];
      if (w === 'bu' && doseAt(T, b + 1) && !coded(C, a, b)) return [a, b + 1, 'bu'];
      if ((/^m[a4][s5][t7][ep]?(?:\d{2,4}(?:mgs?)?)?$/.test(cw) && nLet(w) >= 3) || fw === 'mast' || w === 'mastaron') {
        if ((/^cells?$/.test(nx) || NAME_FOLLOW.test(nx) || /^(?:dr|mr|mrs|ms|prof)$/.test(pv) || nameCoded(C, a, b)) &&
            !stAfter(T, b + 2)) return null;
        return [a, b, 'mast'];
      }
      if (w === 'ma' && (nx === 'e' || nx === 'p')) return [a, b + 1, 'ma' + nx];
      if (/^pr[i1]m[o0][ea]?(?:\d{2,4}(?:mgs?)?)?$/.test(cw) || fw === 'primo' || rep(fw) === 'primo' || /^primobol/.test(w)) {
        return (NAME_FOLLOW.test(nx) && !stAfter(T, b + 2)) ? null : [a, b, 'primo'];
      }
      if (w === 'pr' && nx === 'e') return [a, b + 1, 'pre'];
      if ((m = /^(var|oxa)(\d{2,4})?(?:mgs?)?$/.exec(w)) && !(m[2] ? codedMix(C, a, m[1], m[2]) : coded(C, a, b))) return [a, b, m[1]];
      if (/^w[i1]n+y$/.test(cw)) return [a, b, 'winny'];
      if ((m = /^win(\d{2,4})(?:mgs?)?$/.exec(w)) && doseN(m[1], 25, 200) && !codedMix(C, a, 'win', m[1])) return [a, b, 'win'];
      if (w === 'win' && doseAt(T, b + 1, 25, 200) && !coded(C, a, b)) return [a, b + 1, 'win'];
      if (/^[dt]bol(?:\d{2,4}(?:mgs?)?)?$/.test(cw) || /^[dt]boi$/.test(rep(fw))) return [a, b, w.charAt(0) + 'bol'];
      /* sustanon: sust / Sus 250 / sus250 / 5us 250 (bare "sus" and "$US 250" are fine) */
      if (/^sust(?:\d{2,4}(?:mgs?)?)?$/.test(cw) || /^sust(?:\d{2,4}(?:mgs?)?)?$/.test(clw)) {
        return /^(?:release|released|releasing|rel)$/.test(nx) ? null : [a, b, 'sust'];   /* "Sust. Release" */
      }
      if ((m = /^[s5]u[s5](\d{3})(?:mgs?)?$/.exec(w)) && doseN(m[1], 100)) return [a, b, 'sust'];
      if (/^[s5]u[s5]$/.test(w) && doseAt(T, b + 1, 100)) return [a, b + 1, 'sust'];
      if (cw === 'sustan') return [a, b, 'sust'];
      /* esters: "enan" as a word, Enanth, Enant (enanthate / undecylenate are long names below) */
      if (/^enan(?:t|th)?(?:\d{2,4}(?:mgs?)?)?$/.test(cw) || /^enan(?:t|th)?$/.test(clw)) return [a, b, 'enan'];
      if (/^nandr/.test(fw) || /^stanozoi/.test(fw) || cw === 'anivar') return [a, b, /^n/.test(fw) ? 'nandrolone' : (cw === 'anivar' ? 'anavar' : 'stanozolol')];
    }
    /* the long names, inside a word (look-alike folded, doubled letters collapsed) */
    var cfw = rep(fw);
    for (q = 0; q < ST_RX.length; q++) {
      if (ST_RX[q].test(fw) || ST_RXC[q].test(cfw)) {
        if (ST_WORD[q] === 'masteron' && /Master-?One/.test(C.s.slice(T[a].i, T[b].j))) continue;   /* MasterOne Peptides */
        if (ST_WORD[q] === 'equipoise' && pv === 'clinical') continue;                            /* the research-ethics term */
        return [a, b, ST_WORD[q]];
      }
    }
    /* misspellings of the long names ("Testoterone", "Nandralone", "Equipose", "Winstral") */
    var lf = rep(lw);
    if (/^[a-z]{7,}$/.test(lf)) {
      for (q = 0; q < ST_FUZZ.length; q++) {
        if (ST_FUZZ[q][0] === 'equipoise' && pv === 'clinical') continue;
        if (lev(lf, rep(ST_FUZZ[q][0]), ST_FUZZ[q][1])) return [a, b, ST_FUZZ[q][0]];
      }
    }
    return null;
  }

  function scan(s, raw) {
    if (!/[A-Za-z]/.test(s)) return null;
    var T = [], re = /[A-Za-z0-9]+/g, m, k, z, q = null, i, u, nx;
    while ((m = re.exec(s))) {
      var x = { t: m[0].toLowerCase(), o: m[0], i: m.index, j: m.index + m[0].length };
      /* spaced-out digits are one number ("2 5 0"); an O inside a number is a zero ("1OO", "Test25O") */
      var pt = T[T.length - 1];
      if (/^\d$/.test(x.t) && pt && pt.dr && /^\s+$/.test(s.slice(pt.j, x.i))) { pt.t += x.t; pt.o += x.o; pt.j = x.j; continue; }
      x.dr = /^\d$/.test(x.t);
      if (/\d/.test(x.t) && /o/.test(x.t)) x.t = x.t.replace(/(\d)([\do]*)(?=(?:mgs?)?$)/, function (a0, d0, r) { return d0 + r.replace(/o/g, '0'); });
      T.push(x);
    }
    /* URLs and e-mail addresses: a short word inside one is part of an address ("www.test-labs.com") */
    var X = [], P = Object.create(null), U = [];
    URLRX.lastIndex = 0;
    while ((m = URLRX.exec(s))) for (k = 0; k < T.length; k++) if (T[k].i >= m.index && T[k].j <= m.index + m[0].length) X[k] = 1;
    /* serial prefixes: a code with a leading zero or 4+ digits makes every same-letter number a code */
    for (k = 0; k < T.length; k++) {
      var mm = /^([a-z]{1,4})(\d+)$/.exec(T[k].t);
      if (mm && /^0|^\d{4}/.test(mm[2])) P[mm[1]] = 1;
      if (/^[a-z]{1,4}$/.test(T[k].t) && T[k + 1] && numTok(T[k + 1].t) && /^[-_]?$/.test(s.slice(T[k].j, T[k + 1].i)) &&
          /^0|^\d{4}/.test(T[k + 1].t)) P[T[k].t] = 1;
    }
    var J = ' ' + T.map(function (x) { return x.t; }).join(' ') + ' ';
    var C = { s: s, T: T, X: X, P: P, secr: SECR.test(J) };
    /* every word, plus runs of single letters read as one word ("H G H", "I.U.", never "T&C"),
       two pieces of one short name ("Tr en", "De.ca"), and a word behind a glued number ("200Tren") */
    for (k = 0; k < T.length; k++) U.push({ t: T[k].t, a: k, b: k });
    var R = [];
    for (k = 0; k <= T.length; k++) {
      var one = k < T.length && T[k].t.length === 1 && /[a-z]/.test(T[k].t);
      if (one && q !== null && /&/.test(s.slice(T[k - 1].j, T[k].i))) {
        if (k - q >= 2) R.push({ a: q, b: k - 1 });
        q = null;
      }
      if (one) { if (q === null) q = k; continue; }
      if (q !== null && k - q >= 2) R.push({ a: q, b: k - 1 });
      q = null;
    }
    R.forEach(function (r) {
      var w = ''; for (z = r.a; z <= r.b; z++) w += T[z].t;
      r.t = w; U.push({ t: w, a: r.a, b: r.b });
    });
    for (k = 0; k + 1 < T.length; k++) {
      if (!/^[a-z]+$/.test(T[k].t) || !/^[a-z]+$/.test(T[k + 1].t) || T[k].t.length + T[k + 1].t.length < 3) continue;
      if (T[k].t.length === 1 && T[k + 1].t.length === 1) continue;
      if (!/^[^A-Za-z0-9&\n]{1,3}$/.test(s.slice(T[k].j, T[k + 1].i))) continue;
      var pj = T[k].t + T[k + 1].t;
      if (OWN.call(PAIR_SHORT, pj)) U.push({ t: pj, a: k, b: k + 1, p: 1 });
      else if (OWN.call(PAIR_SHORT, rep(pj))) U.push({ t: rep(pj), a: k, b: k + 1, p: 1 });
    }
    for (k = 0; k < T.length; k++) {
      m = /^\d{2,}([a-z]{2,})$/.exec(T[k].t);                        /* a dose in front, not "3TC" */
      if (m && !UNIT.test(m[1])) U.push({ t: m[1], a: k, b: k, p: 1 });
    }
    function span(u) { return s.slice(T[u.a].i, T[u.b].j); }

    /* 1. human growth hormone */
    for (i = 0; i < U.length; i++) {
      u = U[i]; nx = T[u.b + 1] ? T[u.b + 1].t : '';
      if (ghWord(C, u)) return hit('hgh', span(u), u.t);
      if (u.a === u.b && (u.t === '191' || /^[l1i]9[l1i]$/.test(u.t))) {
        var n2 = T[u.b + 2] ? T[u.b + 2].t : '';
        if (nx === 'aa' || (nx === 'a' && n2 === 'a')) return hit('hgh', s.slice(T[u.a].i, T[u.b + (nx === 'aa' ? 1 : 2)].j), '191aa');
      }
    }
    for (k = 0; k + 1 < T.length; k++) {            /* split in two: "Geno tropin", "Tev-Tropin" */
      var p2 = T[k].t + T[k + 1].t, lp = leet(p2);
      if (SOMA_AT.test(p2) || SOMA_AT.test(lp) || GH_IN.some(function (b) { return p2.indexOf(b) === 0 || lp.indexOf(b) === 0; }))
        return hit('hgh', s.slice(T[k].i, T[k + 1].j), p2);
    }
    var gre = / (?:human ?)?(?:growth|growht|grwoth) ?h[ao]rm(?:one?s?|on)?(?= )/g, gm;
    while ((gm = gre.exec(J))) {                     /* "(human) growth hormone" - not "... releasing / secretagogue / inhibiting" */
      if (!/^ ?(?:releas|secretag|inhibit|rh |rp )/.test(J.slice(gm.index + gm[0].length)) && !C.secr) {
        var gx = /(human[^A-Za-z0-9]*)?gr[a-z]{3,4}[^A-Za-z0-9]*h[ao]rm[a-z]*/i.exec(s);
        return hit('hgh', gx ? gx[0] : 'growth hormone', 'growthhormone');
      }
    }
    if (/ (?:hormona de crecimiento|hormone de croissance|wachstumshormon\w*|hormonio de crescimento|ormone della crescita) /.test(J))
      return hit('hgh', 'growth hormone', 'growthhormone');
    if (/ (?:191|l9l|i9i) amino ?acids? /.test(J)) return hit('hgh', '191 amino acid', '191aa');
    var gn = ghName(C, U);                           /* "Growth", "Growth 120", "Kigs", "Blue Tops" (#1856) */
    if (gn) return hit('hgh', s.slice(T[gn[0]].i, T[gn[1]].j), gn[2]);
    /* 2. steroids - the ester cypionate first (its own word in the message), then the rest */
    for (i = 0; i < U.length; i++) {
      u = U[i];
      if (cypWord(C, u)) return hit('steroid', span(u), u.t);
    }
    for (i = 0; i < U.length; i++) {
      var sw = steroidWord(C, U[i]);
      if (sw) return hit('steroid', s.slice(T[sw[0]].i, T[sw[1]].j), sw[2]);
    }
    for (k = 0; k + 1 < T.length; k++) {            /* split in two: "Testo sterone", "n androlone", "cypi onate" */
      var jn = (T[k].t + T[k + 1].t).replace(/\d+(?:mgs?)?$/, '');
      if (/[a-z]/.test(T[k].t) && /[a-z]/.test(T[k + 1].t) && !(T[k].t.length === 1 && T[k + 1].t.length === 1)) {
        if (OWN.call(ST_PJ, fold(jn))) return hit('steroid', s.slice(T[k].i, T[k + 1].j), ST_PJ[fold(jn)]);
        if (/^[a-z]+$/.test(jn) && CYPW.test(rep(jn))) return hit('steroid', s.slice(T[k].i, T[k + 1].j), 'cypionate');
      }
    }
    /* a name broken up with dashes or dots inside one word: "NAN-DRO-LONE", "TES-TO-STE-RONE" */
    var ws = s.split(/\s+/);
    for (k = 0; k < ws.length; k++) {
      if (!/[^A-Za-z0-9][A-Za-z]/.test(ws[k])) continue;
      var sq = fold(ws[k].toLowerCase().replace(/[^a-z0-9]+/g, ''));
      for (z = 0; z < ST_RX.length; z++) {
        if ((ST_RX[z].test(sq) || ST_RXC[z].test(rep(sq))) && !(ST_WORD[z] === 'masteron' && /Master-?One/.test(ws[k])))
          return hit('steroid', ws[k].replace(/^[^A-Za-z0-9]+|[^A-Za-z0-9]+$/g, ''), ST_WORD[z]);
      }
    }
    /* "Peps And <gear emoji>", "peps & gear", "Peptides and Gear", "PepsAndGear", "P E P S  A N D  G E A R" */
    var J2 = ' ', rk = 0;
    for (k = 0; k < T.length; k++) {
      if (R[rk] && R[rk].a === k) { J2 += R[rk].t + ' '; k = R[rk].b; rk++; continue; }
      J2 += T[k].t + ' ';
    }
    var PG = / p[e3]p(?:tide)?s? ?(?:(?:and|an|n|nd|4nd) ?)?[g9][e3][a4]rs? /;
    if (PG.test(J) || PG.test(J2)) {
      var pg = /p[e3]p(?:tide)?s?[^A-Za-z0-9]*(?:and|an|n|nd|4nd)?[^A-Za-z0-9]*[g9][e3][a4]rs?/i.exec(s);
      return hit('steroid', pg ? pg[0] : 'peps and gear', 'pepsandgear');
    }
    /* 3. a digit / look-alike spelling of a brand the site already blocks ("0zempic", "Mounjar0",
       "O Z E M P I C", "Oze mpic", "Ozzempic", "!OZEMPIC"). A plain spelling standing alone in the
       customer's text stays with the brand lane (its own message). */
    var BFm = brandFold();
    if (BFm) {
      var VB = window.VA_BRANDS, CT = window.VA_BLOCK_CATS || {}, rl = String(raw == null ? '' : raw).toLowerCase();
      var cands = [];
      for (k = 0; k < T.length; k++) {
        cands.push([T[k].t, k, k], [T[k].t.replace(/\d+(?:mgs?|mcg|ml)?$/, ''), k, k], [T[k].t.replace(/^\d+/, ''), k, k]);
        if (T[k + 1] && /^[a-z]{2,}$/.test(T[k].t) && /^[a-z]{2,}$/.test(T[k + 1].t) && T[k].t.length + T[k + 1].t.length >= 7 &&
            /^[^A-Za-z0-9&\n]{1,3}$/.test(s.slice(T[k].j, T[k + 1].i))) cands.push([T[k].t + T[k + 1].t, k, k + 1]);
      }
      R.forEach(function (r) { cands.push([r.t, r.a, r.b]); });
      for (z = 0; z < cands.length; z++) {
        var c = cands[z][0], bk = null;
        if (c.length < 5) continue;
        if (OWN.call(VB, c)) {
          if (new RegExp('(^|[^a-z0-9$@|!])' + c + '($|[^a-z0-9$@|!])').test(rl)) continue;
          bk = /^[a-z]{5,}$/.test(c) ? c : null;
        }
        if (!bk) {
          var fb = fold(c), fg = fold(c.replace(/[69]/g, 'g'));
          if (OWN.call(BFm, fb)) bk = BFm[fb];
          else if (OWN.call(BFm, fg)) bk = BFm[fg];
          else if (OWN.call(BFC, rep(fb)) && c.length >= BFC[rep(fb)].length) bk = BFC[rep(fb)];
          else if (/^[a-z]{6,10}$/.test(c)) {
            for (var fz = 0; fz < FUZZ_BRANDS.length; fz++) if (OWN.call(VB, FUZZ_BRANDS[fz]) && lev(c, FUZZ_BRANDS[fz], 1)) { bk = FUZZ_BRANDS[fz]; break; }
          }
        }
        if (bk) {
          /* the brand list also carries route / dosing / claims / pharmacy wording (off since 09-21, owner)
             and growth-hormone words (lane 1 owns those, with its carve-outs); two words joined never
             read as a controlled substance ("Master One" is not masterone) */
          var bc = OWN.call(CT, bk) ? CT[bk] : 'brand';
          if (bc === 'brand' || bc === 'company' || (bc === 'dea' && cands[z][1] === cands[z][2]))
            return hit(bc, s.slice(T[cands[z][1]].i, T[cands[z][2]].j), bk);
        }
      }
    }
    /* 4. international units */
    for (i = 0; i < U.length; i++) {
      u = U[i];
      if (!u.p && iuWord(C, u)) return hit('iu', span(u), 'iu');
    }
    /* after a number: a lower-case l / | / 1 for the I ("10 lU"), and IU abroad ("10 UI", "10 U.I.", "10 I.E.") */
    m = /(^|[^A-Za-z0-9])\d+(?:[.,]\d+)?(\s*[l|]U|\s+1U|\s*[Uu]\.?\s*[Ii]\.?|\s*I\.?\s*E\.?)(?![A-Za-z0-9])/.exec(s);
    if (m) return hit('iu', m[2].replace(/^\s+/, ''), 'iu');
    if (/ international ?units?[ 0-9]/.test(J) || / \d+ (?:intl|int) units? /.test(J)) return hit('iu', 'international units', 'iu');
    /* 5. mg/mL - an oil concentration, however it is written */
    var ls = s.toLowerCase();
    for (i = 0; i < MGML.length; i++) {
      m = MGML[i].exec(ls);
      if (m) {
        var st = m.index + m[1].length, en = m.index + m[0].length;
        var num = /(\d+(?:[.,]\d+)?\s*)$/.exec(ls.slice(0, st));
        if (num) st -= num[1].length;
        return hit('mgml', ls.length === s.length ? s.slice(st, en) : ls.slice(st, en), 'mg/ml');
      }
    }
    return null;
  }
  function restricted(v) {
    var raw = String(v == null ? '' : v).slice(0, 5000);
    var h = scan(prep(raw, 0), raw);
    if (!h && /[$@|!]/.test(raw)) h = scan(prep(raw, 1), raw);        /* "|HGH|", "!TREN 200", "T|R|E|N" */
    return h;
  }

  window.vaRestrictedHit = function (v) {
    try { return restricted(v); } catch (e) { return null; }
  };
  /* true while a half-typed word could still become an approved compound ("Te" -> Tesamorelin,
     "Gh" -> GHK-Cu): the builders hold an inline warning until the field settles. Add to cart
     never uses this - it always refuses. */
  window.vaRestrictedPending = function (v) {
    try {
      var n = String(v == null ? '' : v).toLowerCase().replace(/[^a-z0-9]+/g, ''), L = window.VA_COMPOUND_LOOKUP;
      if (!n || !L || typeof L !== 'object') return false;
      for (var key in L) {
        if (!OWN.call(L, key)) continue;
        var vals = [key, String(L[key]).toLowerCase().replace(/[^a-z0-9]+/g, '')];
        for (var i = 0; i < 2; i++) if (vals[i].length > n.length && vals[i].indexOf(n) === 0) return true;
      }
    } catch (e) {}
    return false;
  };
})();

/* ===========================================================================
   va-compound-live (owner 2026-08-18): surface the ALLOWLIST refusal AT THE
   COMPOUND FIELD, not only at Review / Add-to-cart.

   Before this, vaCompoundCheck() ran in exactly ONE place — inside
   vaBlockedFields(), which only executes at the review/ATC gate. A customer
   could type an unapproved compound, pick a design, choose a pack and a
   quantity, and only be told "not on our approved compound list" on the
   Review Your Label screen, after the entire build. This screens the field
   itself, the moment they leave it.

   Rules (learned the hard way, see the VA_REFUSAL header):
   - Validate on BLUR/CHANGE only, NEVER per keystroke. Allowlist entries are
     prefixes of one another ("reta" resolves, "ret" does not), so per-key
     validation would refuse half-typed VALID compounds.
   - Fail OPEN if vaCompoundCheck is missing or throws — the review gate and
     the server-side ingest hold both still run behind this.
   - The message renders INLINE at the field: that is the entire point. We do
     NOT call VA_REFUSAL.showDeferred here — it is built to fire once a TYPED
     field settles and did not render on blur in live testing, which left the
     shopper with a red border and no message. The popup still owns the hard
     block at the review/ATC gate. Both read from note(), so the wording
     cannot drift.
   - Don't double-flag: if the brand/claims matcher already marked the field
     (.va-bad), it owns the refusal — stay quiet.
   - Canonicalize on match, same as the review gate ("reta" -> "Retatrutide").
   =========================================================================== */
(function () {
  var FIELD_IDS = { 'va-name': 1, 'vbf-name': 1 };   /* classic + beta */
  var PLACEHOLDER = { 'your compound': 1, 'compound': 1, 'compound name': 1 };

  function note(v) {
    return '\u201C' + v + '\u201D isn\u2019t on our approved compound list. This line can only name an ' +
      'approved research compound (for example Retatrutide, BPC-157, TB-500, NAD+). ' +
      'Adding your brand or lab name? Use the \u201CAdd your logo\u201D option instead \u2014 ' +
      'typed brand text isn\u2019t printed on this line. If your compound is missing, ' +
      'request a review and we\u2019ll consider adding it.';
  }
  window.vaCompoundNote = note;

  function vaBoldWord(box,txt){try{var m=/^(\u26D4 )?\u201C([^\u201D]{1,60})\u201D([\s\S]*)$/.exec(txt);if(!m){box.textContent=txt;return;}box.textContent='';if(m[1])box.appendChild(document.createTextNode(m[1]));box.appendChild(document.createTextNode('\u201C'));var b=document.createElement('b');b.style.cssText='color:#b00020;font-weight:900;';b.textContent=m[2];box.appendChild(b);box.appendChild(document.createTextNode('\u201D'+m[3]));}catch(e){box.textContent=txt;}}
  function inlineBox(el) {
    var b = el.parentNode && el.parentNode.querySelector('.va-cmp-live');
    if (!b && el.parentNode) {
      b = document.createElement('div');
      b.className = 'va-blockmsg va-cmp-live';
      b.setAttribute('role', 'alert');
      b.style.cssText = 'margin:6px 0 2px;padding:8px 10px;border-radius:8px;' +
        'font-size:13px;line-height:1.45;color:#7a4a00;background:#fff6e5;' +
        'border:1px solid #f0c67a;';
      el.parentNode.insertBefore(b, el.nextSibling);
    }
    return b;
  }

  function clearField(el) {
    try {
      el.classList.remove('va-bad');
      var b = el.parentNode && el.parentNode.querySelector('.va-cmp-live');
      if (b && b.parentNode) b.parentNode.removeChild(b);
    } catch (e) {}
  }

  function settle(el) {
    if (!el || !el.id || !FIELD_IDS[el.id]) return;
    if (typeof window.vaCompoundCheck !== 'function') return;       /* fail open */
    var raw = String(el.value == null ? '' : el.value).trim();
    if (!raw || PLACEHOLDER[raw.toLowerCase()]) { clearField(el); return; }

    var alreadyFlagged = false;
    try { alreadyFlagged = el.classList.contains('va-bad'); } catch (e) {}

    /* brand/blocklist first — the rule that fired is the message shown */
    if (!alreadyFlagged) {
      var ch = null;
      try { ch = (typeof window.vaComplianceHit === 'function') ? window.vaComplianceHit(raw) : null; } catch (e) {}
      if (ch) {
        try { el.classList.add('va-bad'); } catch (e) {}
        var bb = inlineBox(el);
        if (bb) { vaBoldWord(bb, '⛔ ' + (ch.note || ('“' + raw + '” can’t be printed.'))); bb.style.display = ''; }
        return;
      }
    }
    var r;
    try { r = window.vaCompoundCheck(raw); } catch (e) { return; }  /* fail open */
    if (!r) return;

    if (r.ok) {
      if (!alreadyFlagged) clearField(el);
      if (r.canon && r.canon !== raw) {/* as-typed (owner 2026-08-18) */;
        try { el.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
      }
      return;
    }

    if (alreadyFlagged) return;   /* brand/claims matcher already owns this field */

    try { el.classList.add('va-bad'); } catch (e) {}
    var b = inlineBox(el);
    if (b) { vaBoldWord(b, '\u26D4 ' + note(raw)); b.style.display = ''; }
  }

  document.addEventListener('blur',   function (e) { settle(e.target); }, true);
  document.addEventListener('change', function (e) { settle(e.target); }, true);
  document.addEventListener('input',  function (e) {
    if (e.target && e.target.id && FIELD_IDS[e.target.id]) clearField(e.target);
  }, true);
})();

/* va-anchor-kill (owner 2026-08-18): the browser's scroll-anchoring was moving
   the page whenever an inline compliance message appeared or vanished. Disable
   it everywhere — layout may grow below the viewport, but the scroll position
   never auto-adjusts again. */
(function(){try{
  var st=document.createElement('style');
  st.textContent='html,body,*{overflow-anchor:none!important}html{scroll-behavior:auto!important}';
  (document.head||document.documentElement).appendChild(st);
}catch(e){}})();

/* va-block-guard (owner 2026-08-18): an inline refusal must also STOP the
   build — while any compliance message is visible, the forward buttons are
   disabled with a tooltip. Re-enables the moment the field is fixed. */
(function(){
  var BTNS=['va-buy','vbf-mconfirm','vbf-mbar-btn','vbf-nudge-go'];
  function blockedNow(){
    /* COMPLIANCE boxes only (hotfix 2026-08-18): the first version also watched
       #vbf-err3 and input.va-bad, which ordinary required-field validation
       uses. One tap of ATC with an empty field flagged va-bad, the guard
       disabled the button, and validation could never re-run to clear it —
       every builder checkout deadlocked while uploads sailed through. */
    try{
      var els=document.querySelectorAll('.va-blockmsg');
      for(var i=0;i<els.length;i++){
        var e=els[i];
        if(e&&e.offsetParent!==null&&(e.textContent||'').replace(/\s+/g,'').length>3)return true;
      }
    }catch(e){}
    return false;
  }
  setInterval(function(){
    var b=blockedNow();
    for(var i=0;i<BTNS.length;i++){
      var el=document.getElementById(BTNS[i]);
      if(!el)continue;
      if(b){
        if(!el.__vaGd){el.__vaGd=1;el.__vaGdT=el.title||'';}
        el.disabled=true;el.style.opacity='.45';el.style.pointerEvents='none';
        el.title='Fix the highlighted field first';
      }else if(el.__vaGd){
        el.__vaGd=0;el.disabled=false;el.style.opacity='';el.style.pointerEvents='';
        el.title=el.__vaGdT||'';
      }
    }
  },500);
})();

/* >>> va-ai-compound >>> */
/* ===========================================================================
   va-ai-compound (owner 2026-09-24): "If it's not a recognized compound that we
   approve it needs to go through the AI checker. Find a cheap one with the API
   keys. We already have through Google."
   Every builder's Add to Cart ends in fetch(): the classic builder, the mobile
   wizard, builder v3 and the beta flow POST the whole label to the design vault
   (window.VA_DESIGN_URL) and then /cart/add.js; Bulk Mix posts /cart/add.js with
   its rows in _mix. This wraps window.fetch ONCE:
     - vault POST: every printed name (Custom Text / Compound Name / Peptide Name /
       Compound, Custom Text 2, Product, Brand, and a strength that is more than an
       amount) is checked. Approved compounds (window.VA_COMPOUND_LOOKUP, the same
       rule as the Worker's ccApproved) pass locally; anything else asks the design
       Worker's POST /compound-check (Gemini Flash-Lite). A refused label gets the
       refusal popup and the vault answers 422, so no design is minted;
     - /cart/add(.js): a body that carries label text (the no-vault fallback, Bulk
       Mix _mix rows) is checked the same way. Within 20 s of a refusal, the SAME
       builder's text-less fallback line (sealed copy, or the refused template with
       no design id) is refused too; any other cart add passes;
     - /cart/change(.js) {id, quantity: 0} ONCE within 20 s of a refusal (builder v3
       edit removes the old line before it adds the new one), so a refused edit
       never deletes the customer's line.
   'unverified' (5.5 s budget - the classic builder aborts its vault call at 8 s -,
   Worker caps, Worker down) and ANY error = the call goes through untouched: Label
   Farm re-checks every order at ingest and holds what fails.
   Review 2026-09-24: GLP / CJC count only as a whole code (GLP-1, GLP-3 R, CJC-1295),
   never as a prefix of joined words ("GLP Dbol2000"); a name with letters outside
   plain ASCII ("BPC-157 + Cyrillic / Chinese") is always asked.
   =========================================================================== */
(function () {
  if (window.__vaAiCompound || typeof window.fetch !== 'function') return;
  window.__vaAiCompound = 1;
  var OF = window.fetch, MEM = {}, LAST = null, SHOWN = {}, WIN = 20000, BUDGET = 5500;
  var NOISE = /^(?:\d+(?:[.,]\d+)?(?:mgs?|mcg|ug|mls?|iu|g|x|u|units?|cc|k)?|mgs?|mcg|ug|mls?|cc|g|x|u|units?|and|with|plus|w|n|blend|blends|mix|stack|combo|vials?|research|lyophilized|lyo|powder|only)$/;
  var CODE_OK = /^(?:glp\d{0,2}(?:r|rt)?|cjc\d{0,4}(?:nodac|dac)?)$/;
  /* micro sign, mu, times, middle dot, en / em dash, curly quotes, (R), degree - the same list as the Worker */
  var ALIEN_OK = String.fromCharCode(0xb5, 0x3bc, 0xd7, 0xb7, 0x2013, 0x2014, 0x2018, 0x2019, 0x201c, 0x201d, 0xae, 0xb0);
  var NAME_KEYS = ['custom text', 'compound name', 'peptide name', 'compound', 'peptide_name', 'peptide', 'name'];
  function now() { return new Date().getTime(); }
  function designUrl() { return String(window.VA_DESIGN_URL || 'https://vialart-design.vialart.workers.dev/design').split(/[?#]/)[0]; }
  var VAULT_ORIGIN = '';
  function checkUrl() {
    var b = VAULT_ORIGIN;
    if (!b) { try { b = new URL(designUrl()).origin; } catch (e) { b = 'https://vialart-design.vialart.workers.dev'; } }
    return b + '/compound-check';
  }
  function toks(s) {
    var t = String(s == null ? '' : s), o = '', alien = false;
    try { t = t.normalize('NFKC'); } catch (e) {}
    t = t.toLowerCase();
    try { t = t.normalize('NFKD'); } catch (e2) {}
    for (var i = 0; i < t.length; i++) {
      var c = t.charCodeAt(i);
      if ((c >= 0x300 && c <= 0x36f) || (c >= 0x1ab0 && c <= 0x1aff) || (c >= 0x1dc0 && c <= 0x1dff) ||
          (c >= 0x20d0 && c <= 0x20ff) || (c >= 0xfe20 && c <= 0xfe2f)) continue;
      if (c > 127 && ALIEN_OK.indexOf(t.charAt(i)) < 0) alien = true;
      o += t.charAt(i);
    }
    var T = o.split(/[^a-z0-9]+/).filter(function (w) { return !!w; });
    T.alien = alien;
    return T;
  }
  function known(k) {
    var L = window.VA_COMPOUND_LOOKUP, own = Object.prototype.hasOwnProperty;
    if (!k) return false;
    if (L && typeof L === 'object') {
      if (own.call(L, k)) return true;
      var a = k.replace(/(?:mgs?|mcg|ug|mls?|iu)$/, ''), b = a.replace(/\d+$/, ''), c = b.replace(/(?:mgs?|mcg|ug|mls?|iu)$/, '');
      if ((a && a !== k && own.call(L, a)) || (b && b !== k && own.call(L, b)) || (c && c !== k && own.call(L, c))) return true;
    }
    return CODE_OK.test(k);
  }
  function noiseOnly(s) {
    var T = toks(s);
    if (T.alien) return false;
    for (var i = 0; i < T.length; i++) if (!NOISE.test(T[i])) return false;
    return true;
  }
  function approved(s) {
    var T = toks(s), i = 0, named = 0;
    if (T.alien) return false;
    while (i < T.length) {
      var n = 0;
      for (var k = Math.min(5, T.length - i); k >= 1; k--) if (known(T.slice(i, i + k).join(''))) { n = k; break; }
      if (n) { named++; i += n; continue; }
      if (!NOISE.test(T[i])) return false;
      i++;
    }
    return named > 0;
  }
  function pickAll(p, keys) {
    var out = [];
    if (!p || typeof p !== 'object') return out;
    for (var k in p) {
      if (!Object.prototype.hasOwnProperty.call(p, k)) continue;
      var v = p[k];
      if (keys.indexOf(String(k).trim().toLowerCase()) >= 0 && v != null && String(v).trim() && out.indexOf(String(v).trim()) < 0) out.push(String(v).trim());
    }
    return out;
  }
  function fieldsOf(p) {
    var nm = pickAll(p, NAME_KEYS);
    var f = { name: nm[0] || '', name2: pickAll(p, ['custom text 2']).join(' / '), product: pickAll(p, ['product']).join(' / '),
              strength: pickAll(p, ['concentration', 'strength', 'dose'])[0] || '', brand: pickAll(p, ['brand']).join(' / '),
              other: nm.slice(1), mix: [] };
    var mx = pickAll(p, ['_mix'])[0];
    if (mx) {
      try {
        var j = JSON.parse(mx), it = (j && j.items) || [];
        for (var i = 0; i < it.length && i < 60; i++) {
          if (it[i] && it[i].compound) f.mix.push({ compound: String(it[i].compound), dose: String(it[i].dose || '') });
        }
      } catch (e) {}
    }
    return f;
  }
  /* every value the check must vouch for - the same list as the Worker's ccNames */
  function names(f) {
    var out = [f.name, f.name2, f.product, f.brand].concat(f.mix.map(function (r) { return r.compound; })).filter(function (x) { return !!x; });
    [f.strength].concat(f.mix.map(function (r) { return r.dose; }), f.other).forEach(function (x) { if (x && !noiseOnly(x)) out.push(x); });
    return out;
  }
  function needs(f) { var n = names(f); return n.length > 0 && !n.every(approved); }
  function check(f, src) {
    var k = JSON.stringify([f.name, f.name2, f.product, f.strength, f.brand, f.mix, f.other]).toLowerCase();
    if (MEM[k]) return Promise.resolve(MEM[k]);
    var body = JSON.stringify({ name: f.name, name2: f.name2, product: f.product, strength: f.strength, brand: f.brand,
                                mix: f.mix, other: f.other, src: src });
    var ask = OF.call(window, checkUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
      .then(function (r) { return r.ok ? r.json() : { verdict: 'unverified' }; })
      .then(function (v) { if (v && (v.verdict === 'allow' || v.verdict === 'block')) MEM[k] = v; return v || { verdict: 'unverified' }; },
            function () { return { verdict: 'unverified' }; });
    var late = new Promise(function (res) { setTimeout(function () { res({ verdict: 'unverified' }); }, BUDGET); });
    return Promise.race([ask, late]);
  }
  /* what the customer entered, for the popup's Request a review form (owner 2026-09-24: the appeal is
     preloaded with what they entered, why we blocked it, and their message) */
  function entered(fl) {
    var out = [];
    (fl || []).forEach(function (f) {
      names(f).forEach(function (x) { if (out.indexOf(x) < 0) out.push(x); });
      if (f.strength && out.indexOf(f.strength) < 0) out.push(f.strength);
    });
    return out.join(' | ').slice(0, 300);
  }
  function refuse(v, fl) {
    var key = String(v.note || v.term || '');
    if (SHOWN[key] && now() - SHOWN[key] < 4000) return;
    SHOWN[key] = now();
    try {
      if (window.VA_REFUSAL && typeof window.VA_REFUSAL.show === 'function') {
        window.VA_REFUSAL.show({ term: v.term || '', restricted: true, kind: 'restricted', category: v.category || '', note: v.note || '' },
                               { field: 'Compound', surface: 'cart', value: entered(fl) });
      }
    } catch (e) {}
  }
  function r422(note) {
    return new Response(JSON.stringify({ status: 422, message: 'Cart Error', description: note || 'This label can\'t be printed.' }),
                        { status: 422, headers: { 'Content-Type': 'application/json' } });
  }
  function urlOf(input) {
    try { return new URL(typeof input === 'string' ? input : (input && input.url) || '', window.location.href); } catch (e) { return null; }
  }
  function bodyOf(init) {
    var b = init && init.body;
    if (b == null) return null;
    if (typeof b === 'string') {
      try { return JSON.parse(b); } catch (e) {}
      try { b = new URLSearchParams(b); } catch (e2) { return null; }
    }
    if ((typeof FormData !== 'undefined' && b instanceof FormData) || (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams)) {
      var o = { properties: {} };
      b.forEach(function (v, k) {
        var m = /^(?:items\[\d*\]\[)?properties\]?\[([^\]]+)\]$/.exec(k);
        if (m && typeof v === 'string') o.properties[m[1]] = v;
        if (k === 'quantity' || k === 'id') o[k] = v;
      });
      return o;
    }
    return null;
  }
  function cartProps(o) {
    if (!o || typeof o !== 'object') return [];
    if (o.items && o.items.length) return o.items.map(function (it) { return (it && it.properties) || {}; });
    return [o.properties || {}];
  }
  function recentBlock() { return LAST && LAST.block && now() - LAST.t < WIN; }
  /* the refused builder's own fallback line: its sealed copy, or its template with no design id */
  function isFallback(p) {
    if (!p || typeof p !== 'object' || p._design_id) return false;
    return !!p._config_enc || (!!LAST.tpl && String(p._template || '') === LAST.tpl);
  }
  window.fetch = function (input, init) {
    var self = this, args = arguments;
    try {
      var method = String((init && init.method) || (input && typeof input === 'object' && input.method) || 'GET').toUpperCase();
      if (method !== 'POST') return OF.apply(self, args);
      var u = urlOf(input);
      if (!u) return OF.apply(self, args);
      var here = u.origin === window.location.origin;
      /* the vault: VA_DESIGN_URL, or any /design POST on a workers.dev host (v3 keeps its own DESIGN_URL) */
      var isVault = (u.origin + u.pathname) === designUrl() || (u.pathname === '/design' && /\.workers\.dev$/.test(u.hostname));
      var isAdd = here && /\/cart\/add(?:\.js)?$/.test(u.pathname);
      var isChange = here && /\/cart\/change(?:\.js)?$/.test(u.pathname);
      if (!isVault && !isAdd && !isChange) return OF.apply(self, args);
      if (isVault) VAULT_ORIGIN = u.origin;
      var o = bodyOf(init);
      if (isChange) {
        if (recentBlock() && !LAST.chg && o && o.id != null && String(o.quantity) === '0') { LAST.chg = true; return Promise.resolve(r422(LAST.note)); }
        return OF.apply(self, args);
      }
      var fl = [], props = isVault ? (o && o.props ? [o.props] : []) : cartProps(o);
      props.forEach(function (p) { var f = fieldsOf(p); if (names(f).length) fl.push(f); });
      if (!fl.length) {
        if (isAdd && recentBlock() && props.some(isFallback)) return Promise.resolve(r422(LAST.note));
        if (isVault) LAST = null;
        return OF.apply(self, args);
      }
      var todo = fl.filter(needs);
      if (!todo.length) { if (isVault) LAST = null; return OF.apply(self, args); }
      var tpl = isVault && o ? String(o.template || (o.props && o.props._template) || '') : '';
      return Promise.all(todo.map(function (f) { return check(f, isVault ? 'vault' : 'cart'); })).then(function (vs) {
        var hit = null;
        for (var i = 0; i < vs.length; i++) if (!hit && vs[i] && vs[i].verdict === 'block') hit = vs[i];
        if (hit) { LAST = { block: true, note: hit.note, t: now(), tpl: tpl, chg: false }; refuse(hit, todo); return r422(hit.note); }
        if (isVault) LAST = null;
        return OF.apply(self, args);
      }, function () { return OF.apply(self, args); });
    } catch (e) {
      return OF.apply(self, args);
    }
  };
})();
/* ===========================================================================
   va-refusal-beacon (owner 2026-09-25: "are all label farm not the front end denials
   i need to see whats happening on front end"). Builder v3, Bulk Mix and most classic
   paths refuse inline and never told anyone. This reports every storefront refusal to
   the scan Worker's /compliance-event (-> Label Farm /compliance, "Typed" rows):
     - an Add to Cart / Confirm / Continue click whose gate check hit the word matcher
       (window.vaRestrictedHit / vaComplianceHit*, wrapped here to remember hits);
     - every refusal popup (VA_REFUSAL.show), which includes the AI compound check.
   Typing alone is never reported. One report per word + place per minute. Best effort:
   any failure is silent and never touches the customer's flow.
   =========================================================================== */
(function () {
  if (window.__vaRfBeacon || typeof document === 'undefined' || !document.addEventListener) return;
  window.__vaRfBeacon = 1;
  var HITS = [], SENT = {};
  function evUrl() {
    return String(window.VA_SCAN_URL || 'https://vialart-scan.vialart.workers.dev/artwork-scan')
      .replace(/\/artwork-scan.*$/, '') + '/compliance-event';
  }
  function send(term, kind, field, note, value) {
    try {
      term = String(term == null ? '' : term).replace(/\s+/g, ' ').trim().slice(0, 80);
      if (!term) return;
      /* the classic builder already reported this word itself (vaCompBeacon, window._vaCB) */
      var cb = window._vaCB || {};
      for (var ck in cb) { if (Object.prototype.hasOwnProperty.call(cb, ck) && ck.toLowerCase().indexOf(term.toLowerCase() + ':') === 0) return; }
      var k = term.toLowerCase() + '|' + field;
      if (SENT[k] && new Date().getTime() - SENT[k] < 60000) return;
      SENT[k] = new Date().getTime();
      var v = String(value == null ? '' : value).replace(/\s+/g, ' ').trim().slice(0, 160);
      var body = JSON.stringify({ term: term, kind: String(kind || 'restricted').slice(0, 30),
        field: String(field || '').slice(0, 80),
        note: (String(note || '').slice(0, 220) + (v && v !== term ? ' | typed: ' + v : '')).slice(0, 400),
        fp: window.VA_FP || '' });
      window.fetch(evUrl(), { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: body, keepalive: true })
        .catch(function () {});
    } catch (e) {}
  }
  function wrap(n) {
    var f = window[n];
    if (typeof f !== 'function' || f.__vaBeacon) return;
    var g = function () {
      var h = f.apply(this, arguments);
      try {
        if (h) {
          HITS.push({ t: new Date().getTime(), h: h, v: arguments[0] });
          if (HITS.length > 50) HITS.shift();
        }
      } catch (e) {}
      return h;
    };
    for (var p in f) { try { if (Object.prototype.hasOwnProperty.call(f, p)) g[p] = f[p]; } catch (e) {} }
    g.__vaBeacon = 1;
    window[n] = g;
  }
  function wrapAll() {
    ['vaRestrictedHit', 'vaComplianceHit', 'vaComplianceHitIdent', 'vaComplianceHitBrandOnly'].forEach(wrap);
    var R = window.VA_REFUSAL;
    if (R && typeof R.show === 'function' && !R.show.__vaBeacon) {
      var s = R.show;
      var g = function (hit, opts) {
        try {
          send((hit && typeof hit === 'object') ? (hit.term || hit.word) : hit,
               (hit && (hit.category || hit.kind)) || 'refusal',
               'Popup ' + ((opts && opts.field) || '') + ' ' + location.pathname,
               (hit && hit.note) || '', opts && opts.value);
        } catch (e) {}
        return s.apply(this, arguments);
      };
      g.__vaBeacon = 1;
      try { R.show = g; } catch (e) {}
    }
  }
  wrapAll();
  document.addEventListener('DOMContentLoaded', wrapAll);
  var ATC = /add to cart|confirm|continue|check ?out|order now/i;
  document.addEventListener('click', function (e) {
    try {
      wrapAll();
      var b = e.target && e.target.closest ? e.target.closest('button, a, input[type=submit]') : null;
      if (!b) return;
      if (!ATC.test((b.textContent || b.value || '') + ' ' + (b.id || '')) && !/buy|atc|confirm/i.test(b.id || '')) return;
      var t0 = new Date().getTime();
      setTimeout(function () {
        for (var i = HITS.length - 1; i >= 0; i--) {
          var x = HITS[i];
          if (x.t < t0 - 50) break;
          var h = x.h;
          send(h.term || h.word || x.v, h.category || h.kind, 'Add to cart ' + location.pathname, h.note || '',
               typeof x.v === 'string' ? x.v : '');
          break;
        }
      }, 1200);
    } catch (err) {}
  }, true);
})();
/* <<< va-ai-compound <<< */


/* >>> va-restricted-extra >>> */
(function(){
  if(window.__vaRxExtra) return; window.__vaRxExtra=1;
/* va-restricted-extra (2026-10-01) - owner: "put blocks for those" after the 09-17..10-01 review:
   #1871 "G 120 mg" (blocked customer Craig Johndrow, after #1852 "GH" and #1856 "Growth" were refused),
   #1838 "EPO" + "MK 677", #1847 "The Hard-R"; then "G120 block it", "also t, c", "all letters".
   2026-10-02 owner "block emojis from input fields": any emoji (explicit code-point list, kept identical in the
   Python port; ™ ® © and plain symbols are NOT emoji here).
   2026-10-02 (owner "do all"): disease-cure claims (cure/treat/reverse/prevent/heal + a disease, "miracle cure",
   "divine healing") and pharmacy/authenticity markings (Rx only, NDC, verify authenticity, certificate of authenticity).
   2026-10-08 owner "block any sort of juice, rooster" after #2037 "Rooster Juice" printed: steroid slang JUICE (any
   spelling or join: Juiced, PimpJuice, J U I C E, Ju1ce, Jooce) and ROOSTER (Roosters, R00ster), anywhere in any field.
   2026-10-08 owner "block human": HUMAN anywhere (Human, SUPER HUMAN BLEND, Superhuman, For human use, Hum4n) unless the
   same sentence negates it ("Not for Human or Animal Consumption", "Not for Human or Veterinary Use" = 89 past jobs).
   Humanin (a research peptide) stays allowed.
   A field that is ONE letter (or GH / HG), alone or with a number of up to 4 digits (G, G 120, G120, T-800, X 10 IU)
   is a code name, never a product: refused. Pass: lot-style codes glued to the letter with < 3 digits (G7, G12, T3,
   B12), B-12 / B 12 (vitamin), T500 / T-500 (TB-500 typo, owner 09-24), T/C in mcg, and 5+ digit lots (GH0920261).
   The same rules run in the upload-scan Worker and in Label Farm core/compliance.py (_extra_restricted). */
var VA_RX_LONE = /^\s*([a-z]|gh|hg|g\s+h)(\s*[-_.#:\/]?\s*)(?:(\d{1,4}(?:\.\d+)?)\s*(iu|mg|mcg|ml|units?)?)?\s*$/i;
var VA_RX_EXTRA = [
  ['emoji', /[\u{1F000}-\u{1FAFF}\u{1F1E6}-\u{1F1FF}⌚⌛⏩-⏳⏸-⏺◽◾☔☕♈-♓♿⚓⚡⚪⚫⚽⚾⛄⛅⛎⛔⛪⛲⛳⛵⛺⛽✅✊✋✨❌❎❓-❕❗➕-➗➰➿⬛⬜⭐⭕️⃣]+/u],
  ['epo', /\b(?:e\.?\s?p\.?\s?o\b\.?|epoetin|epoietin|erythropoie?tin|erythropoeitin|epogen|procrit|retacrit|eprex|binocrit|aranesp|darbepoetin|mircera)/i],
  ['sarm', /\b(?:mk\W{0,3}0?677|ibutamoren|nutrobal)\b/i],
  ['claim', /\b(?:miracle\W+cure|cure\W?all|divine\W+healing|faith\W+healing|god'?s\W+medicine)\b|\b(?:cures?|cured|curing|treats?|treated|treating|treatments?|revers(?:e|es|ed|ing)|prevents?|prevented|preventing|prevention|heals?|healed|healing)\b(?:\W+\w+){0,3}?\W+(?:cancers?|tumou?rs?|leuka?emia|lymphoma|diabetes|alzheimer'?s?|dementia|parkinson'?s?|hiv|aids|covid(?:-?19)?|hepatitis|heart\W+disease|strokes?|arthritis|lupus|multiple\W+sclerosis|autism|kidney\W+disease|liver\W+disease|copd|asthma|epilepsy|infections?|diseases?)\b|\b(?:cancers?|tumou?rs?|leuka?emia|lymphoma|diabetes|alzheimer'?s?|dementia|parkinson'?s?|hiv|aids|covid(?:-?19)?|hepatitis|heart\W+disease|strokes?|arthritis|lupus|multiple\W+sclerosis|autism|kidney\W+disease|liver\W+disease|copd|asthma|epilepsy|infections?|diseases?)\W+(?:cure|treatment|remedy)\b/i],
  ['counterfeit', /\brx\W{0,2}only\b|℞\W{0,2}only\b|\bndc\b(?:\W{0,3}(?:#|no|code|\d))?|\bverify\W+(?:its\W+|product\W+)?authenticity\b|\bauthenticity\W+(?:guaranteed|verified|seal|hologram)\b|\bcertificate\W+of\W+authenticity\b|\banti\W?counterfeit\b|\bfda\W{0,3}(?:approved|registered|registration|certified|certificate|cleared|listed|compliant)\b|\busp\W{0,3}verified\b|\bc?gmp\W{0,3}certified\b|\bgovernment\W+approved\b/i],
  ['slang', /j+\W{0,2}u+\W{0,2}[i1!|l]+\W{0,2}c+\W{0,2}[e3y]+|j[o0]{2,}c[e3y]|r+\W{0,2}[o0]+\W{0,2}[o0]+\W{0,2}s+\W{0,2}t+\W{0,2}[e3]+\W{0,2}r+/i],
  ['human', /h+\W{0,2}u+\W{0,2}m+\W{0,2}[a4@]+\W{0,2}n(?!\W{0,2}i\W{0,2}n\b)/i],
  ['fda', /\bf\W{0,2}d\W{0,2}a\b|\bfood\W+(?:and|&)\W+drug\W+admin(?:istration)?\b/i]
  /* 2026-10-28 owner: "we don't care about offensive stuff. We care about scheduled" - the 'offensive' rule (hard-r / n-word) is gone. */
];
var VA_RX_EXTRA_MSG = {
  emoji: 'Emojis can’t be printed on labels. Please remove “{t}”.',
  hgh: '“{t}” is a restricted growth-hormone product. We can’t print labels for it.',
  steroid: '“{t}” is a steroid product. We can’t print labels for it.',
  code: '“{t}” isn’t a product name we can print. Please type the full compound name.',
  epo: '“{t}” is a prescription drug (EPO). We can’t print labels for it.',
  sarm: '“{t}” (MK-677) is a restricted product. We can’t print labels for it.',
  claim: '“{t}” is a health or cure claim. We can’t print health or cure claims on labels.',
  counterfeit: '“{t}” is a pharmacy, authenticity or regulatory-approval marking. We can’t print it on labels.',
  slang: '“{t}” is steroid slang. We can’t print labels for it.',
  human: 'We can’t print “{t}”.',
  fda: '“{t}” can’t be printed. Labels can’t mention the FDA.',
  offensive: 'We can’t print “{t}”. Please remove offensive language from your label.'
};
function vaRxHit(t, c) {
  return { term: t, word: t.toLowerCase(), kind: 'restricted', category: c, note: VA_RX_EXTRA_MSG[c].replace('{t}', t), restricted: true, suggest: '' };
}
/* opts.noLone (2026-10-02): artwork / logo text from the upload scanner skips the lone-letter rule - a one-letter
   monogram logo ("R", "N") is normal artwork, not a code name. Typed label fields always apply it. */
function vaRxExtra(v, opts) {
  var s = String(v == null ? '' : v); if (!s.replace(/\s+/g, '')) return null;
  var m = (opts && opts.noLone) ? null : VA_RX_LONE.exec(s);
  if (m) {
    var l = m[1].replace(/\s+/g, '').toLowerCase(), gap = m[2] || '', num = m[3], unit = (m[4] || '').toLowerCase(), n = num ? parseInt(num, 10) : null;
    var lotish = num && !gap.length && String(n).length < 3 && num.replace(/\..*/, '').length < 3 && !unit;   /* G7, G12, T3 */
    var ok = lotish || (l === 'b' && n === 12) || (l === 't' && n === 500) || (unit === 'mcg' && (l === 't' || l === 'c'));   /* B-12, TB-500 typo, mcg */
    if (!ok) return vaRxHit(s.replace(/^\s+|\s+$/g, ''), /^(g|h|gh|hg)$/.test(l) ? 'hgh' : (/^(t|c)$/.test(l) ? 'steroid' : 'code'));
  }
  for (var i = 0; i < VA_RX_EXTRA.length; i++) {
    var cat = VA_RX_EXTRA[i][0], re = new RegExp(VA_RX_EXTRA[i][1].source, VA_RX_EXTRA[i][1].flags.replace('g', '') + 'g'), x;
    while ((x = re.exec(s))) {
      /* a claim NEGATED in the same sentence is a disclaimer ("not intended to diagnose, treat, cure or prevent any disease") */
      if ((cat === 'claim' || cat === 'counterfeit' || cat === 'human' || cat === 'fda') && /\b(?:not|never|no|nor|without)\b/i.test(s.slice(Math.max(0, x.index - 60), x.index).split(cat === 'human' ? /[.!?;|•]/ : /[.!?;\n|•]/).pop())) { if (re.lastIndex === x.index) re.lastIndex++; continue; }
      return vaRxHit((x[0] || s).replace(/^\s+|\s+$/g, '') || s.trim(), cat);
    }
  }
  return null;
}
  window.vaRxExtra = vaRxExtra;
  function wrap(){ var o=window.vaRestrictedHit; if(typeof o!=='function'||o.__rxx) return typeof o==='function';
    var w=function(v){ var h=o.apply(this,arguments); if(h) return h; try{ return vaRxExtra(v); }catch(e){ return null; } };
    for(var k in o){ try{ w[k]=o[k]; }catch(_){} } w.__rxx=1; window.vaRestrictedHit=w; return true; }
  if(!wrap()){ var n=0, iv=setInterval(function(){ if(wrap()||++n>60) clearInterval(iv); }, 250); }
  else { var m=0, iv2=setInterval(function(){ wrap(); if(++m>40) clearInterval(iv2); }, 500); }
})();
/* <<< va-restricted-extra <<< */


/* >>> va-emoji-strip >>> (2026-10-02, owner: "block emojis from input fields")
   Label text fields in every builder (ids va-*, vbf-*, v3-*, vas-*, vai2-*) drop emojis as they are typed or pasted and
   show a short note. The restricted lane (va-restricted-extra 'emoji') still refuses at Add to Cart and Label Farm holds,
   so a value set by script cannot slip through. TM, (R), (C) and plain symbols are not emoji here. */
(function(){
  if (window.__vaEmojiStrip) return; window.__vaEmojiStrip = 1;
  var RE = /[\u{1F000}-\u{1FAFF}\u{1F1E6}-\u{1F1FF}⌚⌛⏩-⏳⏸-⏺◽◾☔☕♈-♓♿⚓⚡⚪⚫⚽⚾⛄⛅⛎⛔⛪⛲⛳⛵⛺⛽✅✊✋✨❌❎❓-❕❗➕-➗➰➿⬛⬜⭐⭕️⃣‍]/gu;
  var IDS = /^(va|vbf|v3|vas|vai2|va-blk)[-_]/i, SKIP = /(email|mail|search|qr|url|link|notes?|msg|message)/i;
  function field(el){ return el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') && IDS.test(el.id || '') && !SKIP.test(el.id || '') &&
                       !/^(email|search|url|tel|number|file|checkbox|radio|hidden|password)$/i.test(el.type || ''); }
  function note(el){
    var n = document.getElementById('va-emo-note'); if (n) n.remove();
    n = document.createElement('div'); n.id = 'va-emo-note'; n.setAttribute('role', 'status');
    n.textContent = 'Emojis can’t be printed on labels, so we removed them.';
    n.style.cssText = 'margin:6px 0 0;padding:7px 10px;border-radius:8px;font-size:12.5px;font-weight:600;background:rgba(255,107,107,.12);border:1px solid rgba(255,107,107,.45);color:inherit';
    try { el.insertAdjacentElement('afterend', n); } catch (_) {}
    setTimeout(function(){ try { n.remove(); } catch (_) {} }, 3500);
  }
  document.addEventListener('input', function(ev){
    var el = ev.target; if (!field(el)) return;
    /* invisible format characters (LRM/RLM, zero-width space/joiner/non-joiner, BOM, word joiner, bidi embeds, soft
       hyphen) ride along when text is pasted from phones/PDFs - invisible here, but they broke the print (#1980).
       Removed silently: there is nothing for the customer to see. */
    var _raw = String(el.value || ''), _inv = /[\u00AD\u200B\u200C\u200E\u200F\u202A-\u202E\u2060-\u2064\uFEFF]/g;
    if (_inv.test(_raw)) { var _p0 = el.selectionStart, _cl = _raw.replace(_inv, ''); el.value = _cl;
      try { if (_p0 != null) { var _np = Math.max(0, _p0 - (_raw.length - _cl.length)); el.setSelectionRange(_np, _np); } } catch (_) {} }
    var v = String(el.value || ''); if (!v || !RE.test(v)) return; RE.lastIndex = 0;
    var pos = el.selectionStart, before = v.length;
    el.value = v.replace(RE, ''); RE.lastIndex = 0;
    try { var d = before - el.value.length; if (pos != null) el.setSelectionRange(Math.max(0, pos - d), Math.max(0, pos - d)); } catch (_) {}
    note(el);
  }, true);
})();
/* <<< va-emoji-strip <<< */
